export const SCENE_ANIMATION_3 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "prisoner,-0.909,0.000,-3.343,0.000,0.000,0.000,-1.000",
                "citizenM,6.996,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.889,0.455,-0.132,0.003,0.995,-0.095,0.028"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "prisoner,-0.909,0.000,-3.343,0.000,0.000,0.000,-1.000",
                "citizenM,6.996,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.889,0.455,-0.132,0.003,0.995,-0.095,0.028"
            ]
        },
        {
            "time": 0.041999999433755878,
            "data": [
                "prisoner,-0.909,0.000,-3.340,0.000,0.000,0.000,-1.000",
                "citizenM,6.996,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.878,0.453,-0.125,0.003,0.995,-0.094,0.025"
            ]
        },
        {
            "time": 0.061000000685453418,
            "data": [
                "prisoner,-0.909,0.000,-3.335,0.000,0.000,0.000,-1.000",
                "citizenM,6.995,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.866,0.451,-0.117,0.002,0.995,-0.093,0.020"
            ]
        },
        {
            "time": 0.07599999755620957,
            "data": [
                "prisoner,-0.909,0.000,-3.322,0.000,0.000,0.000,-1.000",
                "citizenM,6.995,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.844,0.447,-0.104,0.002,0.996,-0.092,0.013"
            ]
        },
        {
            "time": 0.07900000363588333,
            "data": [
                "prisoner,-0.909,0.000,-3.309,0.000,0.000,0.000,-1.000",
                "citizenM,6.994,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.829,0.444,-0.094,0.001,0.996,-0.091,0.008"
            ]
        },
        {
            "time": 0.09399999678134918,
            "data": [
                "prisoner,-0.909,0.000,-3.306,0.000,0.000,0.000,-1.000",
                "citizenM,6.994,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.825,0.444,-0.091,0.001,0.996,-0.091,0.007"
            ]
        },
        {
            "time": 0.10899999737739563,
            "data": [
                "prisoner,-0.909,0.000,-3.290,0.000,0.000,0.000,-1.000",
                "citizenM,6.993,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.809,0.441,-0.081,0.001,0.996,-0.090,0.001"
            ]
        },
        {
            "time": 0.12300000339746475,
            "data": [
                "prisoner,-0.909,0.000,-3.272,0.000,0.000,0.000,-1.000",
                "citizenM,6.992,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.793,0.438,-0.071,0.000,0.996,-0.089,-0.004"
            ]
        },
        {
            "time": 0.1379999965429306,
            "data": [
                "prisoner,-0.909,0.000,-3.251,0.000,0.000,0.000,-1.000",
                "citizenM,6.991,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.777,0.435,-0.060,0.000,0.996,-0.088,-0.009"
            ]
        },
        {
            "time": 0.15199999511241914,
            "data": [
                "prisoner,-0.909,0.000,-3.229,0.000,0.000,0.000,-1.000",
                "citizenM,6.989,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.761,0.432,-0.050,-0.001,0.996,-0.087,-0.015"
            ]
        },
        {
            "time": 0.16599999368190766,
            "data": [
                "prisoner,-0.909,0.000,-3.204,0.000,0.000,0.000,-1.000",
                "citizenM,6.988,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.745,0.429,-0.040,-0.001,0.996,-0.086,-0.020"
            ]
        },
        {
            "time": 0.18000000715255738,
            "data": [
                "prisoner,-0.909,0.000,-3.178,0.000,0.000,0.000,-1.000",
                "citizenM,6.986,0.000,1.598,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.730,0.426,-0.030,-0.002,0.996,-0.085,-0.025"
            ]
        },
        {
            "time": 0.19099999964237214,
            "data": [
                "prisoner,-0.909,0.000,-3.151,0.000,0.000,0.000,-1.000",
                "citizenM,6.984,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.715,0.424,-0.021,-0.002,0.996,-0.084,-0.030"
            ]
        },
        {
            "time": 0.20600000023841859,
            "data": [
                "prisoner,-0.909,0.000,-3.128,0.000,0.000,0.000,-1.000",
                "citizenM,6.983,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.703,0.422,-0.013,-0.002,0.996,-0.084,-0.034"
            ]
        },
        {
            "time": 0.2199999988079071,
            "data": [
                "prisoner,-0.909,0.000,-3.096,0.000,0.000,0.000,-1.000",
                "citizenM,6.981,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.687,0.419,-0.003,-0.003,0.996,-0.083,-0.039"
            ]
        },
        {
            "time": 0.23399999737739564,
            "data": [
                "prisoner,-0.909,0.000,-3.064,0.000,0.000,0.000,-1.000",
                "citizenM,6.979,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.672,0.416,0.007,-0.003,0.996,-0.082,-0.044"
            ]
        },
        {
            "time": 0.24799999594688416,
            "data": [
                "prisoner,-0.909,0.000,-3.030,0.000,0.000,0.000,-1.000",
                "citizenM,6.977,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.657,0.413,0.017,-0.004,0.995,-0.081,-0.050"
            ]
        },
        {
            "time": 0.2630000114440918,
            "data": [
                "prisoner,-0.909,0.000,-2.995,0.000,0.000,0.000,-1.000",
                "citizenM,6.974,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.642,0.410,0.026,-0.004,0.995,-0.080,-0.055"
            ]
        },
        {
            "time": 0.27900001406669619,
            "data": [
                "prisoner,-0.909,0.000,-2.954,0.000,0.000,0.000,-1.000",
                "citizenM,6.972,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.625,0.407,0.037,-0.004,0.995,-0.079,-0.060"
            ]
        },
        {
            "time": 0.289000004529953,
            "data": [
                "prisoner,-0.909,0.000,-2.910,0.000,0.000,0.000,-1.000",
                "citizenM,6.969,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.608,0.404,0.048,-0.005,0.995,-0.078,-0.066"
            ]
        },
        {
            "time": 0.30300000309944155,
            "data": [
                "prisoner,-0.909,0.000,-2.883,0.000,0.000,0.000,-1.000",
                "citizenM,6.967,0.000,1.597,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.597,0.402,0.055,-0.005,0.995,-0.077,-0.070"
            ]
        },
        {
            "time": 0.3160000145435333,
            "data": [
                "prisoner,-0.909,0.000,-2.843,0.000,0.000,0.000,-1.000",
                "citizenM,6.964,0.000,1.596,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.582,0.400,0.065,-0.005,0.994,-0.076,-0.075"
            ]
        },
        {
            "time": 0.3319999873638153,
            "data": [
                "prisoner,-0.909,0.000,-2.804,0.000,0.000,0.000,-1.000",
                "citizenM,6.961,0.000,1.596,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.568,0.397,0.074,-0.006,0.994,-0.076,-0.079"
            ]
        },
        {
            "time": 0.34700000286102297,
            "data": [
                "prisoner,-0.909,0.000,-2.754,0.000,0.000,0.000,-1.000",
                "citizenM,6.958,0.000,1.596,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.550,0.394,0.085,-0.006,0.994,-0.075,-0.085"
            ]
        },
        {
            "time": 0.35899999737739565,
            "data": [
                "prisoner,-0.909,0.000,-2.709,0.000,0.000,0.000,-1.000",
                "citizenM,6.954,0.000,1.596,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.534,0.391,0.095,-0.006,0.993,-0.074,-0.091"
            ]
        },
        {
            "time": 0.375,
            "data": [
                "prisoner,-0.909,0.000,-2.670,0.000,0.000,0.000,-1.000",
                "citizenM,6.951,0.000,1.596,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.521,0.389,0.104,-0.006,0.993,-0.073,-0.095"
            ]
        },
        {
            "time": 0.3869999945163727,
            "data": [
                "prisoner,-0.909,0.000,-2.616,0.000,0.000,0.000,-1.000",
                "citizenM,6.947,0.000,1.596,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.503,0.386,0.115,-0.007,0.992,-0.072,-0.101"
            ]
        },
        {
            "time": 0.40400001406669619,
            "data": [
                "prisoner,-0.909,0.000,-2.577,0.000,0.000,0.000,-1.000",
                "citizenM,6.944,0.000,1.595,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.490,0.383,0.124,-0.007,0.992,-0.071,-0.105"
            ]
        },
        {
            "time": 0.4129999876022339,
            "data": [
                "prisoner,-0.909,0.000,-2.518,0.000,0.000,0.000,-1.000",
                "citizenM,6.940,0.000,1.595,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.472,0.380,0.136,-0.007,0.991,-0.070,-0.112"
            ]
        },
        {
            "time": 0.42800000309944155,
            "data": [
                "prisoner,-0.909,0.000,-2.487,0.000,0.000,0.000,-1.000",
                "citizenM,6.937,0.000,1.595,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.462,0.378,0.142,-0.008,0.991,-0.069,-0.115"
            ]
        },
        {
            "time": 0.4440000057220459,
            "data": [
                "prisoner,-0.909,0.000,-2.438,0.000,0.000,0.000,-1.000",
                "citizenM,6.933,0.000,1.595,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.446,0.375,0.152,-0.008,0.990,-0.068,-0.120"
            ]
        },
        {
            "time": 0.4569999873638153,
            "data": [
                "prisoner,-0.909,0.000,-2.379,0.000,0.000,0.000,-1.000",
                "citizenM,6.928,0.000,1.595,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.428,0.372,0.164,-0.008,0.990,-0.067,-0.126"
            ]
        },
        {
            "time": 0.4729999899864197,
            "data": [
                "prisoner,-0.909,0.000,-2.335,0.000,0.000,0.000,-1.000",
                "citizenM,6.925,0.000,1.595,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.414,0.370,0.172,-0.008,0.989,-0.066,-0.131"
            ]
        },
        {
            "time": 0.4869999885559082,
            "data": [
                "prisoner,-0.909,0.000,-2.277,0.000,0.000,0.000,-1.000",
                "citizenM,6.920,0.000,1.594,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.397,0.366,0.184,-0.008,0.988,-0.065,-0.137"
            ]
        },
        {
            "time": 0.503000020980835,
            "data": [
                "prisoner,-0.909,0.000,-2.228,0.000,0.000,0.000,-1.000",
                "citizenM,6.916,0.000,1.594,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.382,0.364,0.193,-0.009,0.988,-0.064,-0.142"
            ]
        },
        {
            "time": 0.5130000114440918,
            "data": [
                "prisoner,-0.909,0.000,-2.169,0.000,0.000,0.000,-1.000",
                "citizenM,6.910,0.000,1.594,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.364,0.361,0.205,-0.009,0.987,-0.063,-0.147"
            ]
        },
        {
            "time": 0.5260000228881836,
            "data": [
                "prisoner,-0.909,0.000,-2.132,0.000,0.000,0.000,-1.000",
                "citizenM,6.907,0.000,1.594,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.353,0.359,0.212,-0.009,0.986,-0.063,-0.151"
            ]
        },
        {
            "time": 0.5400000214576721,
            "data": [
                "prisoner,-0.909,0.000,-2.088,0.000,0.000,0.000,-1.000",
                "citizenM,6.903,0.000,1.593,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.340,0.356,0.220,-0.009,0.986,-0.062,-0.156"
            ]
        },
        {
            "time": 0.5559999942779541,
            "data": [
                "prisoner,-0.909,0.000,-2.035,0.000,0.000,0.000,-1.000",
                "citizenM,6.898,0.000,1.593,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.324,0.353,0.230,-0.009,0.985,-0.061,-0.161"
            ]
        },
        {
            "time": 0.5709999799728394,
            "data": [
                "prisoner,-0.909,0.000,-1.976,0.000,0.000,0.000,-1.000",
                "citizenM,6.892,0.000,1.593,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.306,0.350,0.242,-0.010,0.984,-0.060,-0.167"
            ]
        },
        {
            "time": 0.5849999785423279,
            "data": [
                "prisoner,-0.909,0.000,-1.922,0.000,0.000,0.000,-1.000",
                "citizenM,6.887,0.000,1.593,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.290,0.347,0.252,-0.010,0.983,-0.059,-0.172"
            ]
        },
        {
            "time": 0.5989999771118164,
            "data": [
                "prisoner,-0.909,0.000,-1.873,0.000,0.000,0.000,-1.000",
                "citizenM,6.882,0.000,1.592,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.275,0.345,0.262,-0.010,0.982,-0.058,-0.177"
            ]
        },
        {
            "time": 0.6150000095367432,
            "data": [
                "prisoner,-0.909,0.000,-1.822,0.000,0.000,0.000,-1.000",
                "citizenM,6.876,0.000,1.592,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.260,0.342,0.272,-0.010,0.982,-0.057,-0.182"
            ]
        },
        {
            "time": 0.625,
            "data": [
                "prisoner,-0.909,0.000,-1.765,0.000,0.000,0.000,-1.000",
                "citizenM,6.870,0.000,1.592,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.242,0.339,0.283,-0.010,0.981,-0.056,-0.188"
            ]
        },
        {
            "time": 0.6370000243186951,
            "data": [
                "prisoner,-0.909,0.000,-1.730,0.000,0.000,0.000,-1.000",
                "citizenM,6.866,0.000,1.592,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.232,0.337,0.290,-0.010,0.980,-0.055,-0.191"
            ]
        },
        {
            "time": 0.6520000100135803,
            "data": [
                "prisoner,-0.909,0.000,-1.687,0.000,0.000,0.000,-1.000",
                "citizenM,6.861,0.000,1.591,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.218,0.334,0.298,-0.010,0.979,-0.054,-0.196"
            ]
        },
        {
            "time": 0.6679999828338623,
            "data": [
                "prisoner,-0.909,0.000,-1.635,0.000,0.000,0.000,-1.000",
                "citizenM,6.855,0.000,1.591,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.202,0.331,0.309,-0.010,0.978,-0.054,-0.201"
            ]
        },
        {
            "time": 0.6809999942779541,
            "data": [
                "prisoner,-0.909,0.000,-1.579,0.000,0.000,0.000,-1.000",
                "citizenM,6.849,0.000,1.591,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.185,0.328,0.320,-0.011,0.977,-0.052,-0.207"
            ]
        },
        {
            "time": 0.6970000267028809,
            "data": [
                "prisoner,-0.909,0.000,-1.535,0.000,0.000,0.000,-1.000",
                "citizenM,6.843,0.000,1.591,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.171,0.326,0.329,-0.011,0.976,-0.052,-0.212"
            ]
        },
        {
            "time": 0.7099999785423279,
            "data": [
                "prisoner,-0.909,0.000,-1.484,0.000,0.000,0.000,-1.000",
                "citizenM,6.837,0.000,1.590,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.154,0.323,0.340,-0.011,0.975,-0.051,-0.217"
            ]
        },
        {
            "time": 0.7229999899864197,
            "data": [
                "prisoner,-0.909,0.000,-1.440,0.000,0.000,0.000,-1.000",
                "citizenM,6.831,0.000,1.590,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.140,0.320,0.349,-0.011,0.974,-0.050,-0.222"
            ]
        },
        {
            "time": 0.7369999885559082,
            "data": [
                "prisoner,-0.909,0.000,-1.398,0.000,0.000,0.000,-1.000",
                "citizenM,6.825,0.000,1.590,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.125,0.318,0.358,-0.011,0.973,-0.049,-0.227"
            ]
        },
        {
            "time": 0.7490000128746033,
            "data": [
                "prisoner,-0.909,0.000,-1.354,0.000,0.000,0.000,-1.000",
                "citizenM,6.819,0.000,1.589,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.110,0.315,0.368,-0.011,0.972,-0.048,-0.231"
            ]
        },
        {
            "time": 0.7649999856948853,
            "data": [
                "prisoner,-0.909,0.000,-1.317,0.000,0.000,0.000,-1.000",
                "citizenM,6.814,0.000,1.589,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.097,0.313,0.376,-0.011,0.971,-0.047,-0.236"
            ]
        },
        {
            "time": 0.777999997138977,
            "data": [
                "prisoner,-0.909,0.000,-1.268,0.000,0.000,0.000,-1.000",
                "citizenM,6.806,0.000,1.589,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.080,0.309,0.387,-0.011,0.969,-0.046,-0.242"
            ]
        },
        {
            "time": 0.7919999957084656,
            "data": [
                "prisoner,-0.909,0.000,-1.231,0.000,0.000,0.000,-1.000",
                "citizenM,6.800,0.000,1.588,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.066,0.307,0.396,-0.011,0.968,-0.045,-0.246"
            ]
        },
        {
            "time": 0.8090000152587891,
            "data": [
                "prisoner,-0.909,0.000,-1.189,0.000,0.000,0.000,-1.000",
                "citizenM,6.793,0.000,1.588,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.050,0.304,0.406,-0.011,0.967,-0.044,-0.251"
            ]
        },
        {
            "time": 0.8209999799728394,
            "data": [
                "prisoner,-0.909,0.000,-1.144,0.000,0.000,0.000,-1.000",
                "citizenM,6.785,0.000,1.588,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.032,0.301,0.418,-0.011,0.965,-0.043,-0.257"
            ]
        },
        {
            "time": 0.8349999785423279,
            "data": [
                "prisoner,-0.909,0.000,-1.112,0.000,0.000,0.000,-1.000",
                "citizenM,6.780,0.000,1.587,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.019,0.298,0.426,-0.011,0.964,-0.042,-0.261"
            ]
        },
        {
            "time": 0.8500000238418579,
            "data": [
                "prisoner,-0.909,0.000,-1.076,0.000,0.000,0.000,-1.000",
                "citizenM,6.773,0.000,1.587,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.004,0.296,0.436,-0.011,0.963,-0.042,-0.266"
            ]
        },
        {
            "time": 0.8629999756813049,
            "data": [
                "prisoner,-0.909,0.000,-1.039,0.000,0.000,0.000,-1.000",
                "citizenM,6.765,0.000,1.587,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.012,0.293,0.446,-0.011,0.962,-0.041,-0.271"
            ]
        },
        {
            "time": 0.8759999871253967,
            "data": [
                "prisoner,-0.909,0.000,-1.008,0.000,0.000,0.000,-1.000",
                "citizenM,6.758,0.000,1.586,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.027,0.290,0.455,-0.011,0.960,-0.040,-0.276"
            ]
        },
        {
            "time": 0.8899999856948853,
            "data": [
                "prisoner,-0.909,0.000,-0.979,0.000,0.000,0.000,-1.000",
                "citizenM,6.752,0.000,1.586,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.041,0.288,0.464,-0.011,0.959,-0.039,-0.281"
            ]
        },
        {
            "time": 0.9049999713897705,
            "data": [
                "prisoner,-0.909,0.000,-0.949,0.000,0.000,0.000,-1.000",
                "citizenM,6.744,0.000,1.586,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.056,0.285,0.474,-0.011,0.958,-0.038,-0.286"
            ]
        },
        {
            "time": 0.9190000295639038,
            "data": [
                "prisoner,-0.909,0.000,-0.919,0.000,0.000,0.000,-1.000",
                "citizenM,6.737,0.000,1.585,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.072,0.282,0.485,-0.011,0.956,-0.037,-0.291"
            ]
        },
        {
            "time": 0.9340000152587891,
            "data": [
                "prisoner,-0.909,0.000,-0.893,0.000,0.000,0.000,-1.000",
                "citizenM,6.729,0.000,1.585,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.088,0.279,0.495,-0.011,0.954,-0.036,-0.296"
            ]
        },
        {
            "time": 0.9490000009536743,
            "data": [
                "prisoner,-0.909,0.000,-0.868,0.000,0.000,0.000,-1.000",
                "citizenM,6.721,0.000,1.585,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.104,0.276,0.505,-0.010,0.953,-0.035,-0.301"
            ]
        },
        {
            "time": 0.9599999785423279,
            "data": [
                "prisoner,-0.909,0.000,-0.844,0.000,0.000,0.000,-1.000",
                "citizenM,6.713,0.000,1.584,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.120,0.273,0.515,-0.010,0.951,-0.034,-0.306"
            ]
        },
        {
            "time": 0.9729999899864197,
            "data": [
                "prisoner,-0.909,0.000,-0.827,0.000,0.000,0.000,-1.000",
                "citizenM,6.707,0.000,1.584,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.133,0.271,0.524,-0.010,0.950,-0.033,-0.310"
            ]
        },
        {
            "time": 0.9890000224113464,
            "data": [
                "prisoner,-0.909,0.000,-0.811,0.000,0.000,0.000,-1.000",
                "citizenM,6.700,0.000,1.583,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.146,0.269,0.532,-0.010,0.949,-0.033,-0.315"
            ]
        },
        {
            "time": 1.003999948501587,
            "data": [
                "prisoner,-0.909,0.000,-0.792,0.000,0.000,0.000,-1.000",
                "citizenM,6.691,0.000,1.583,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.164,0.266,0.544,-0.010,0.947,-0.032,-0.320"
            ]
        },
        {
            "time": 1.0160000324249268,
            "data": [
                "prisoner,-0.909,0.000,-0.778,0.000,0.000,0.000,-1.000",
                "citizenM,6.682,0.000,1.583,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.176,0.263,0.552,-0.010,0.946,-0.031,-0.324"
            ]
        },
        {
            "time": 1.031999945640564,
            "data": [
                "prisoner,-0.909,0.000,-0.766,0.000,0.000,0.000,-1.000",
                "citizenM,6.675,0.000,1.582,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.177,0.264,0.556,-0.010,0.946,-0.031,-0.322"
            ]
        },
        {
            "time": 1.0460000038146973,
            "data": [
                "prisoner,-0.908,0.000,-0.752,0.000,-0.001,0.000,-1.000",
                "citizenM,6.666,0.000,1.582,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.178,0.264,0.561,-0.010,0.947,-0.031,-0.320"
            ]
        },
        {
            "time": 1.062000036239624,
            "data": [
                "prisoner,-0.908,0.000,-0.740,0.000,-0.001,0.000,-1.000",
                "citizenM,6.658,0.000,1.581,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.179,0.264,0.565,-0.010,0.948,-0.031,-0.318"
            ]
        },
        {
            "time": 1.0750000476837159,
            "data": [
                "prisoner,-0.906,0.000,-0.726,0.000,-0.003,0.000,-1.000",
                "citizenM,6.648,0.000,1.581,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.180,0.265,0.570,-0.010,0.948,-0.031,-0.316"
            ]
        },
        {
            "time": 1.0859999656677247,
            "data": [
                "prisoner,-0.905,0.000,-0.715,0.000,-0.004,0.000,-1.000",
                "citizenM,6.640,0.000,1.581,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.181,0.265,0.574,-0.010,0.949,-0.031,-0.314"
            ]
        },
        {
            "time": 1.1009999513626099,
            "data": [
                "prisoner,-0.904,0.000,-0.706,0.000,-0.005,0.000,-1.000",
                "citizenM,6.634,0.000,1.580,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.182,0.265,0.577,-0.010,0.949,-0.031,-0.312"
            ]
        },
        {
            "time": 1.1150000095367432,
            "data": [
                "prisoner,-0.902,0.000,-0.694,0.000,-0.007,0.000,-1.000",
                "citizenM,6.625,0.000,1.580,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.183,0.266,0.582,-0.010,0.950,-0.031,-0.310"
            ]
        },
        {
            "time": 1.1299999952316285,
            "data": [
                "prisoner,-0.900,0.000,-0.683,0.000,-0.009,0.000,-1.000",
                "citizenM,6.616,0.000,1.579,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.184,0.266,0.586,-0.009,0.951,-0.031,-0.308"
            ]
        },
        {
            "time": 1.1419999599456788,
            "data": [
                "prisoner,-0.897,0.000,-0.672,0.000,-0.011,0.000,-1.000",
                "citizenM,6.607,0.000,1.579,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.185,0.266,0.591,-0.009,0.951,-0.031,-0.306"
            ]
        },
        {
            "time": 1.156999945640564,
            "data": [
                "prisoner,-0.895,0.000,-0.662,0.000,-0.013,0.000,-1.000",
                "citizenM,6.599,0.000,1.579,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.186,0.267,0.595,-0.009,0.952,-0.031,-0.305"
            ]
        },
        {
            "time": 1.1710000038146973,
            "data": [
                "prisoner,-0.892,0.000,-0.651,0.000,-0.016,0.000,-1.000",
                "citizenM,6.590,0.000,1.578,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.188,0.267,0.599,-0.009,0.953,-0.031,-0.302"
            ]
        },
        {
            "time": 1.184000015258789,
            "data": [
                "prisoner,-0.889,0.000,-0.641,0.000,-0.019,0.000,-1.000",
                "citizenM,6.581,0.000,1.578,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.189,0.267,0.604,-0.009,0.953,-0.031,-0.301"
            ]
        },
        {
            "time": 1.1970000267028809,
            "data": [
                "prisoner,-0.886,0.000,-0.632,0.000,-0.022,0.000,-1.000",
                "citizenM,6.573,0.000,1.577,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.190,0.267,0.608,-0.009,0.954,-0.031,-0.299"
            ]
        },
        {
            "time": 1.2109999656677247,
            "data": [
                "prisoner,-0.883,0.000,-0.624,0.000,-0.025,0.000,-1.000",
                "citizenM,6.565,0.000,1.577,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.190,0.268,0.611,-0.009,0.954,-0.031,-0.297"
            ]
        },
        {
            "time": 1.225000023841858,
            "data": [
                "prisoner,-0.879,0.000,-0.614,0.000,-0.028,0.000,-1.000",
                "citizenM,6.556,0.000,1.576,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.191,0.268,0.616,-0.009,0.955,-0.031,-0.295"
            ]
        },
        {
            "time": 1.2400000095367432,
            "data": [
                "prisoner,-0.875,0.000,-0.605,0.000,-0.032,0.000,-0.999",
                "citizenM,6.546,0.000,1.576,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.193,0.268,0.620,-0.009,0.956,-0.031,-0.293"
            ]
        },
        {
            "time": 1.253999948501587,
            "data": [
                "prisoner,-0.871,0.000,-0.595,0.000,-0.036,0.000,-0.999",
                "citizenM,6.537,0.000,1.575,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.194,0.269,0.625,-0.009,0.956,-0.032,-0.291"
            ]
        },
        {
            "time": 1.2680000066757203,
            "data": [
                "prisoner,-0.867,0.000,-0.587,0.000,-0.040,0.000,-0.999",
                "citizenM,6.528,0.000,1.575,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.195,0.269,0.629,-0.009,0.957,-0.032,-0.289"
            ]
        },
        {
            "time": 1.2860000133514405,
            "data": [
                "prisoner,-0.862,0.000,-0.578,0.000,-0.044,0.000,-0.999",
                "citizenM,6.518,0.000,1.575,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.196,0.269,0.633,-0.009,0.957,-0.032,-0.287"
            ]
        },
        {
            "time": 1.3020000457763672,
            "data": [
                "prisoner,-0.856,0.000,-0.568,0.000,-0.050,0.000,-0.999",
                "citizenM,6.506,0.000,1.574,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.197,0.270,0.638,-0.009,0.958,-0.032,-0.285"
            ]
        },
        {
            "time": 1.3070000410079957,
            "data": [
                "prisoner,-0.850,0.000,-0.559,0.000,-0.055,0.000,-0.998",
                "citizenM,6.496,0.000,1.573,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.198,0.270,0.643,-0.009,0.959,-0.032,-0.283"
            ]
        },
        {
            "time": 1.3220000267028809,
            "data": [
                "prisoner,-0.848,0.000,-0.556,0.000,-0.057,0.000,-0.998",
                "citizenM,6.492,0.000,1.573,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.199,0.270,0.645,-0.009,0.959,-0.032,-0.282"
            ]
        },
        {
            "time": 1.3370000123977662,
            "data": [
                "prisoner,-0.842,0.000,-0.548,0.000,-0.062,0.000,-0.998",
                "citizenM,6.482,0.000,1.573,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.200,0.270,0.650,-0.009,0.960,-0.032,-0.280"
            ]
        },
        {
            "time": 1.3530000448226929,
            "data": [
                "prisoner,-0.836,0.000,-0.540,0.000,-0.067,0.000,-0.998",
                "citizenM,6.472,0.000,1.572,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.201,0.271,0.654,-0.009,0.960,-0.032,-0.278"
            ]
        },
        {
            "time": 1.3680000305175782,
            "data": [
                "prisoner,-0.830,0.000,-0.532,0.000,-0.073,0.000,-0.997",
                "citizenM,6.461,0.000,1.572,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.202,0.271,0.659,-0.009,0.961,-0.032,-0.275"
            ]
        },
        {
            "time": 1.3799999952316285,
            "data": [
                "prisoner,-0.823,0.000,-0.524,0.000,-0.079,0.000,-0.997",
                "citizenM,6.450,0.000,1.571,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.203,0.271,0.664,-0.008,0.961,-0.032,-0.273"
            ]
        },
        {
            "time": 1.3940000534057618,
            "data": [
                "prisoner,-0.818,0.000,-0.518,0.000,-0.084,0.000,-0.996",
                "citizenM,6.441,0.000,1.571,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.204,0.272,0.667,-0.008,0.962,-0.032,-0.272"
            ]
        },
        {
            "time": 1.409000039100647,
            "data": [
                "prisoner,-0.811,0.000,-0.511,0.000,-0.089,0.000,-0.996",
                "citizenM,6.432,0.000,1.570,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.205,0.272,0.672,-0.008,0.962,-0.032,-0.270"
            ]
        },
        {
            "time": 1.4210000038146973,
            "data": [
                "prisoner,-0.804,0.000,-0.504,0.000,-0.096,0.000,-0.995",
                "citizenM,6.421,0.000,1.570,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.206,0.272,0.676,-0.008,0.963,-0.032,-0.268"
            ]
        },
        {
            "time": 1.4359999895095826,
            "data": [
                "prisoner,-0.799,0.000,-0.499,0.000,-0.100,0.000,-0.995",
                "citizenM,6.413,0.000,1.569,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.207,0.273,0.680,-0.008,0.963,-0.032,-0.266"
            ]
        },
        {
            "time": 1.4520000219345093,
            "data": [
                "prisoner,-0.791,0.000,-0.493,0.000,-0.107,0.000,-0.994",
                "citizenM,6.402,0.000,1.569,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.208,0.273,0.684,-0.008,0.964,-0.032,-0.264"
            ]
        },
        {
            "time": 1.465999960899353,
            "data": [
                "prisoner,-0.783,0.000,-0.485,0.000,-0.114,0.000,-0.993",
                "citizenM,6.390,0.000,1.568,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.209,0.273,0.689,-0.008,0.965,-0.032,-0.262"
            ]
        },
        {
            "time": 1.4809999465942383,
            "data": [
                "prisoner,-0.776,0.000,-0.480,0.000,-0.120,0.000,-0.993",
                "citizenM,6.381,0.000,1.568,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.210,0.274,0.693,-0.008,0.965,-0.032,-0.260"
            ]
        },
        {
            "time": 1.5069999694824219,
            "data": [
                "prisoner,-0.768,0.000,-0.474,0.000,-0.127,0.000,-0.992",
                "citizenM,6.370,0.000,1.567,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.211,0.274,0.698,-0.008,0.966,-0.032,-0.258"
            ]
        },
        {
            "time": 1.5089999437332154,
            "data": [
                "prisoner,-0.754,0.000,-0.463,0.000,-0.139,0.000,-0.990",
                "citizenM,6.351,0.000,1.566,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.213,0.274,0.706,-0.008,0.967,-0.032,-0.254"
            ]
        },
        {
            "time": 1.5230000019073487,
            "data": [
                "prisoner,-0.753,0.000,-0.463,0.000,-0.140,0.000,-0.990",
                "citizenM,6.349,0.000,1.566,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.213,0.275,0.707,-0.008,0.967,-0.032,-0.254"
            ]
        },
        {
            "time": 1.5390000343322755,
            "data": [
                "prisoner,-0.745,0.000,-0.457,0.000,-0.146,0.000,-0.989",
                "citizenM,6.338,0.000,1.566,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.215,0.275,0.711,-0.008,0.967,-0.032,-0.252"
            ]
        },
        {
            "time": 1.5509999990463257,
            "data": [
                "prisoner,-0.736,0.000,-0.452,0.000,-0.154,0.000,-0.988",
                "citizenM,6.327,0.000,1.565,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.216,0.275,0.716,-0.008,0.968,-0.032,-0.249"
            ]
        },
        {
            "time": 1.565999984741211,
            "data": [
                "prisoner,-0.729,0.000,-0.447,0.000,-0.159,0.000,-0.987",
                "citizenM,6.318,0.000,1.565,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.217,0.275,0.719,-0.008,0.968,-0.032,-0.248"
            ]
        },
        {
            "time": 1.5820000171661378,
            "data": [
                "prisoner,-0.720,0.000,-0.442,0.000,-0.167,0.000,-0.986",
                "citizenM,6.307,0.000,1.564,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.218,0.276,0.724,-0.008,0.969,-0.032,-0.246"
            ]
        },
        {
            "time": 1.5959999561309815,
            "data": [
                "prisoner,-0.710,0.000,-0.437,0.000,-0.175,0.000,-0.985",
                "citizenM,6.295,0.000,1.564,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.219,0.276,0.729,-0.008,0.969,-0.032,-0.243"
            ]
        },
        {
            "time": 1.6130000352859498,
            "data": [
                "prisoner,-0.702,0.000,-0.432,0.000,-0.181,0.000,-0.983",
                "citizenM,6.285,0.000,1.563,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.220,0.276,0.733,-0.007,0.970,-0.033,-0.241"
            ]
        },
        {
            "time": 1.6260000467300416,
            "data": [
                "prisoner,-0.691,0.000,-0.427,0.000,-0.190,0.000,-0.982",
                "citizenM,6.272,0.000,1.563,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.221,0.277,0.738,-0.007,0.970,-0.033,-0.239"
            ]
        },
        {
            "time": 1.6349999904632569,
            "data": [
                "prisoner,-0.683,0.000,-0.423,0.000,-0.196,0.000,-0.981",
                "citizenM,6.262,0.000,1.562,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.222,0.277,0.742,-0.007,0.971,-0.033,-0.237"
            ]
        },
        {
            "time": 1.6510000228881837,
            "data": [
                "prisoner,-0.677,0.000,-0.420,0.000,-0.201,0.000,-0.980",
                "citizenM,6.255,0.000,1.562,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.223,0.277,0.745,-0.007,0.971,-0.033,-0.236"
            ]
        },
        {
            "time": 1.6640000343322755,
            "data": [
                "prisoner,-0.667,0.000,-0.415,0.000,-0.209,0.000,-0.978",
                "citizenM,6.243,0.000,1.561,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.224,0.278,0.750,-0.007,0.972,-0.033,-0.234"
            ]
        },
        {
            "time": 1.6779999732971192,
            "data": [
                "prisoner,-0.658,0.000,-0.411,0.000,-0.215,0.000,-0.977",
                "citizenM,6.233,0.000,1.561,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.225,0.278,0.754,-0.007,0.972,-0.033,-0.232"
            ]
        },
        {
            "time": 1.6929999589920045,
            "data": [
                "prisoner,-0.649,0.000,-0.407,0.000,-0.223,0.000,-0.975",
                "citizenM,6.222,0.000,1.560,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.226,0.278,0.758,-0.007,0.973,-0.033,-0.230"
            ]
        },
        {
            "time": 1.7070000171661378,
            "data": [
                "prisoner,-0.639,0.000,-0.403,0.000,-0.230,0.000,-0.973",
                "citizenM,6.210,0.000,1.560,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.227,0.279,0.763,-0.007,0.973,-0.033,-0.228"
            ]
        },
        {
            "time": 1.725000023841858,
            "data": [
                "prisoner,-0.629,0.000,-0.399,0.000,-0.237,0.000,-0.971",
                "citizenM,6.199,0.000,1.559,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.228,0.279,0.767,-0.007,0.974,-0.033,-0.226"
            ]
        },
        {
            "time": 1.7339999675750733,
            "data": [
                "prisoner,-0.617,0.000,-0.395,0.000,-0.246,0.000,-0.969",
                "citizenM,6.185,0.000,1.558,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.229,0.279,0.773,-0.007,0.974,-0.033,-0.223"
            ]
        },
        {
            "time": 1.746999979019165,
            "data": [
                "prisoner,-0.610,0.000,-0.392,0.000,-0.251,0.000,-0.968",
                "citizenM,6.178,0.000,1.558,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.230,0.279,0.775,-0.007,0.974,-0.033,-0.222"
            ]
        },
        {
            "time": 1.7640000581741334,
            "data": [
                "prisoner,-0.602,0.000,-0.389,0.000,-0.257,0.000,-0.966",
                "citizenM,6.168,0.000,1.557,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.231,0.280,0.779,-0.007,0.975,-0.033,-0.220"
            ]
        },
        {
            "time": 1.777999997138977,
            "data": [
                "prisoner,-0.590,0.000,-0.385,0.000,-0.266,0.000,-0.964",
                "citizenM,6.155,0.000,1.557,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.232,0.280,0.784,-0.007,0.975,-0.033,-0.218"
            ]
        },
        {
            "time": 1.7910000085830689,
            "data": [
                "prisoner,-0.580,0.000,-0.381,0.000,-0.273,0.000,-0.962",
                "citizenM,6.144,0.000,1.556,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.233,0.280,0.789,-0.007,0.976,-0.033,-0.216"
            ]
        },
        {
            "time": 1.8049999475479127,
            "data": [
                "prisoner,-0.571,0.000,-0.378,0.000,-0.279,0.000,-0.960",
                "citizenM,6.134,0.000,1.556,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.234,0.281,0.793,-0.007,0.976,-0.033,-0.214"
            ]
        },
        {
            "time": 1.8209999799728394,
            "data": [
                "prisoner,-0.560,0.000,-0.375,0.000,-0.286,0.000,-0.958",
                "citizenM,6.123,0.000,1.555,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.235,0.281,0.797,-0.007,0.977,-0.033,-0.212"
            ]
        },
        {
            "time": 1.8370000123977662,
            "data": [
                "prisoner,-0.549,0.000,-0.371,0.000,-0.294,0.000,-0.956",
                "citizenM,6.110,0.000,1.555,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.237,0.281,0.802,-0.006,0.977,-0.033,-0.210"
            ]
        },
        {
            "time": 1.8509999513626099,
            "data": [
                "prisoner,-0.537,0.000,-0.368,0.000,-0.303,0.000,-0.953",
                "citizenM,6.097,0.000,1.554,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.238,0.282,0.807,-0.006,0.978,-0.033,-0.207"
            ]
        },
        {
            "time": 1.8609999418258668,
            "data": [
                "prisoner,-0.527,0.000,-0.364,0.000,-0.309,0.000,-0.951",
                "citizenM,6.086,0.000,1.553,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.239,0.282,0.811,-0.006,0.978,-0.033,-0.205"
            ]
        },
        {
            "time": 1.875,
            "data": [
                "prisoner,-0.519,0.000,-0.362,0.000,-0.314,0.000,-0.949",
                "citizenM,6.078,0.000,1.553,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.239,0.282,0.814,-0.006,0.978,-0.033,-0.204"
            ]
        },
        {
            "time": 1.8910000324249268,
            "data": [
                "prisoner,-0.509,0.000,-0.359,0.000,-0.321,0.000,-0.947",
                "citizenM,6.067,0.000,1.552,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.240,0.283,0.818,-0.006,0.979,-0.033,-0.202"
            ]
        },
        {
            "time": 1.9040000438690186,
            "data": [
                "prisoner,-0.497,0.000,-0.356,0.000,-0.329,0.000,-0.944",
                "citizenM,6.054,0.000,1.552,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.242,0.283,0.823,-0.006,0.979,-0.033,-0.200"
            ]
        },
        {
            "time": 1.9199999570846558,
            "data": [
                "prisoner,-0.487,0.000,-0.353,0.000,-0.335,0.000,-0.942",
                "citizenM,6.044,0.000,1.551,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.243,0.283,0.827,-0.006,0.980,-0.033,-0.198"
            ]
        },
        {
            "time": 1.934999942779541,
            "data": [
                "prisoner,-0.475,0.000,-0.349,0.000,-0.342,0.000,-0.940",
                "citizenM,6.031,0.000,1.551,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.244,0.284,0.832,-0.006,0.980,-0.033,-0.196"
            ]
        },
        {
            "time": 1.9490000009536744,
            "data": [
                "prisoner,-0.464,0.000,-0.346,0.000,-0.349,0.000,-0.937",
                "citizenM,6.019,0.000,1.550,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.245,0.284,0.837,-0.006,0.981,-0.033,-0.194"
            ]
        },
        {
            "time": 1.965999960899353,
            "data": [
                "prisoner,-0.453,0.000,-0.343,0.000,-0.356,0.000,-0.935",
                "citizenM,6.007,0.000,1.550,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.246,0.284,0.841,-0.006,0.981,-0.033,-0.192"
            ]
        },
        {
            "time": 1.975000023841858,
            "data": [
                "prisoner,-0.440,0.000,-0.340,0.000,-0.363,0.000,-0.932",
                "citizenM,5.994,0.000,1.549,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.247,0.285,0.846,-0.006,0.981,-0.033,-0.189"
            ]
        },
        {
            "time": 1.9889999628067017,
            "data": [
                "prisoner,-0.434,0.000,-0.338,0.000,-0.367,0.000,-0.930",
                "citizenM,5.987,0.000,1.549,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.248,0.285,0.849,-0.006,0.982,-0.033,-0.188"
            ]
        },
        {
            "time": 2.003999948501587,
            "data": [
                "prisoner,-0.422,0.000,-0.335,0.000,-0.373,0.000,-0.928",
                "citizenM,5.975,0.000,1.548,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.249,0.285,0.853,-0.006,0.982,-0.033,-0.186"
            ]
        },
        {
            "time": 2.0199999809265138,
            "data": [
                "prisoner,-0.411,0.000,-0.332,0.000,-0.380,0.000,-0.925",
                "citizenM,5.963,0.000,1.547,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.250,0.285,0.858,-0.006,0.982,-0.034,-0.184"
            ]
        },
        {
            "time": 2.0339999198913576,
            "data": [
                "prisoner,-0.398,0.000,-0.329,0.000,-0.387,0.000,-0.922",
                "citizenM,5.949,0.000,1.547,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.251,0.286,0.863,-0.006,0.983,-0.034,-0.181"
            ]
        },
        {
            "time": 2.0510001182556154,
            "data": [
                "prisoner,-0.388,0.000,-0.326,0.000,-0.393,0.000,-0.920",
                "citizenM,5.938,0.000,1.546,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.252,0.286,0.867,-0.006,0.983,-0.034,-0.179"
            ]
        },
        {
            "time": 2.062000036239624,
            "data": [
                "prisoner,-0.375,0.000,-0.322,0.000,-0.399,0.000,-0.917",
                "citizenM,5.924,0.000,1.546,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.254,0.286,0.872,-0.005,0.984,-0.034,-0.177"
            ]
        },
        {
            "time": 2.0769999027252199,
            "data": [
                "prisoner,-0.366,0.000,-0.320,0.000,-0.404,0.000,-0.915",
                "citizenM,5.915,0.000,1.545,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.254,0.287,0.876,-0.005,0.984,-0.034,-0.175"
            ]
        },
        {
            "time": 2.0920000076293947,
            "data": [
                "prisoner,-0.355,0.000,-0.317,0.000,-0.410,0.000,-0.912",
                "citizenM,5.903,0.000,1.544,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.255,0.287,0.880,-0.005,0.984,-0.034,-0.173"
            ]
        },
        {
            "time": 2.1070001125335695,
            "data": [
                "prisoner,-0.343,0.000,-0.314,0.000,-0.415,0.000,-0.910",
                "citizenM,5.891,0.000,1.544,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.257,0.287,0.885,-0.005,0.985,-0.034,-0.171"
            ]
        },
        {
            "time": 2.11899995803833,
            "data": [
                "prisoner,-0.332,0.000,-0.310,0.000,-0.421,0.000,-0.907",
                "citizenM,5.879,0.000,1.543,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.258,0.288,0.889,-0.005,0.985,-0.034,-0.169"
            ]
        },
        {
            "time": 2.132999897003174,
            "data": [
                "prisoner,-0.322,0.000,-0.308,0.000,-0.425,0.000,-0.905",
                "citizenM,5.869,0.000,1.543,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.259,0.288,0.893,-0.005,0.985,-0.034,-0.167"
            ]
        },
        {
            "time": 2.1480000019073488,
            "data": [
                "prisoner,-0.311,0.000,-0.305,0.000,-0.430,0.000,-0.903",
                "citizenM,5.857,0.000,1.542,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.260,0.288,0.897,-0.005,0.986,-0.034,-0.165"
            ]
        },
        {
            "time": 2.1659998893737795,
            "data": [
                "prisoner,-0.300,0.000,-0.301,0.000,-0.435,0.000,-0.900",
                "citizenM,5.845,0.000,1.542,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.261,0.288,0.902,-0.005,0.986,-0.034,-0.163"
            ]
        },
        {
            "time": 2.178999900817871,
            "data": [
                "prisoner,-0.285,0.000,-0.297,0.000,-0.442,0.000,-0.897",
                "citizenM,5.830,0.000,1.541,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.262,0.289,0.907,-0.005,0.986,-0.034,-0.161"
            ]
        },
        {
            "time": 2.187999963760376,
            "data": [
                "prisoner,-0.276,0.000,-0.294,0.000,-0.446,0.000,-0.895",
                "citizenM,5.819,0.000,1.540,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.263,0.289,0.911,-0.005,0.987,-0.034,-0.159"
            ]
        },
        {
            "time": 2.2039999961853029,
            "data": [
                "prisoner,-0.269,0.000,-0.292,0.000,-0.448,0.000,-0.894",
                "citizenM,5.812,0.000,1.540,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.264,0.289,0.914,-0.005,0.987,-0.034,-0.158"
            ]
        },
        {
            "time": 2.2170000076293947,
            "data": [
                "prisoner,-0.256,0.000,-0.288,0.000,-0.453,0.000,-0.891",
                "citizenM,5.799,0.000,1.539,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.265,0.290,0.919,-0.005,0.987,-0.034,-0.155"
            ]
        },
        {
            "time": 2.2330000400543215,
            "data": [
                "prisoner,-0.247,0.000,-0.285,0.000,-0.457,0.000,-0.889",
                "citizenM,5.788,0.000,1.539,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.266,0.290,0.923,-0.005,0.988,-0.034,-0.153"
            ]
        },
        {
            "time": 2.247999906539917,
            "data": [
                "prisoner,-0.234,0.000,-0.281,0.000,-0.462,0.000,-0.887",
                "citizenM,5.775,0.000,1.538,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.267,0.290,0.928,-0.005,0.988,-0.034,-0.151"
            ]
        },
        {
            "time": 2.265000104904175,
            "data": [
                "prisoner,-0.223,0.000,-0.277,0.000,-0.465,0.000,-0.885",
                "citizenM,5.763,0.000,1.538,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.268,0.291,0.932,-0.005,0.988,-0.034,-0.149"
            ]
        },
        {
            "time": 2.2739999294281008,
            "data": [
                "prisoner,-0.210,0.000,-0.273,0.000,-0.470,0.000,-0.883",
                "citizenM,5.749,0.000,1.537,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.269,0.291,0.937,-0.004,0.989,-0.034,-0.146"
            ]
        },
        {
            "time": 2.2890000343322756,
            "data": [
                "prisoner,-0.203,0.000,-0.270,0.000,-0.472,0.000,-0.882",
                "citizenM,5.741,0.000,1.537,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.270,0.291,0.940,-0.004,0.989,-0.034,-0.145"
            ]
        },
        {
            "time": 2.3010001182556154,
            "data": [
                "prisoner,-0.193,0.000,-0.267,0.000,-0.475,0.000,-0.880",
                "citizenM,5.729,0.000,1.536,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.271,0.292,0.945,-0.004,0.989,-0.034,-0.143"
            ]
        },
        {
            "time": 2.315999984741211,
            "data": [
                "prisoner,-0.183,0.000,-0.263,0.000,-0.478,0.000,-0.878",
                "citizenM,5.719,0.000,1.535,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.272,0.292,0.948,-0.004,0.989,-0.034,-0.141"
            ]
        },
        {
            "time": 2.3369998931884767,
            "data": [
                "prisoner,-0.172,0.000,-0.259,0.000,-0.481,0.000,-0.877",
                "citizenM,5.706,0.000,1.535,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.273,0.292,0.953,-0.004,0.990,-0.034,-0.139"
            ]
        },
        {
            "time": 2.3589999675750734,
            "data": [
                "prisoner,-0.157,0.000,-0.253,0.000,-0.485,0.000,-0.874",
                "citizenM,5.689,0.000,1.534,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.275,0.293,0.959,-0.004,0.990,-0.034,-0.136"
            ]
        },
        {
            "time": 2.3610000610351564,
            "data": [
                "prisoner,-0.141,0.000,-0.246,0.000,-0.489,0.000,-0.872",
                "citizenM,5.672,0.000,1.533,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.276,0.293,0.966,-0.004,0.991,-0.034,-0.133"
            ]
        },
        {
            "time": 2.377000093460083,
            "data": [
                "prisoner,-0.139,0.000,-0.246,0.000,-0.489,0.000,-0.872",
                "citizenM,5.670,0.000,1.533,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.276,0.293,0.967,-0.004,0.991,-0.034,-0.133"
            ]
        },
        {
            "time": 2.38700008392334,
            "data": [
                "prisoner,-0.128,0.000,-0.241,0.000,-0.491,0.000,-0.871",
                "citizenM,5.656,0.000,1.532,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.278,0.294,0.972,-0.004,0.991,-0.034,-0.130"
            ]
        },
        {
            "time": 2.4040000438690187,
            "data": [
                "prisoner,-0.120,0.000,-0.237,0.000,-0.493,0.000,-0.870",
                "citizenM,5.648,0.000,1.532,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.278,0.294,0.975,-0.004,0.991,-0.034,-0.129"
            ]
        },
        {
            "time": 2.4179999828338625,
            "data": [
                "prisoner,-0.109,0.000,-0.232,0.000,-0.495,0.000,-0.869",
                "citizenM,5.635,0.000,1.531,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.280,0.294,0.980,-0.004,0.991,-0.034,-0.127"
            ]
        },
        {
            "time": 2.430999994277954,
            "data": [
                "prisoner,-0.099,0.000,-0.227,0.000,-0.496,0.000,-0.868",
                "citizenM,5.623,0.000,1.531,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.281,0.294,0.984,-0.004,0.992,-0.034,-0.124"
            ]
        },
        {
            "time": 2.447000026702881,
            "data": [
                "prisoner,-0.089,0.000,-0.223,0.000,-0.497,0.000,-0.868",
                "citizenM,5.612,0.000,1.530,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.282,0.295,0.988,-0.004,0.992,-0.034,-0.123"
            ]
        },
        {
            "time": 2.4600000381469728,
            "data": [
                "prisoner,-0.079,0.000,-0.217,0.000,-0.498,0.000,-0.867",
                "citizenM,5.599,0.000,1.530,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.283,0.295,0.993,-0.004,0.992,-0.035,-0.120"
            ]
        },
        {
            "time": 2.4779999256134035,
            "data": [
                "prisoner,-0.070,0.000,-0.212,0.000,-0.499,0.000,-0.867",
                "citizenM,5.588,0.000,1.529,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.284,0.295,0.997,-0.004,0.992,-0.035,-0.118"
            ]
        },
        {
            "time": 2.492000102996826,
            "data": [
                "prisoner,-0.057,0.000,-0.205,0.000,-0.500,0.000,-0.866",
                "citizenM,5.574,0.000,1.528,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.285,0.296,1.002,-0.003,0.993,-0.035,-0.116"
            ]
        },
        {
            "time": 2.502000093460083,
            "data": [
                "prisoner,-0.048,0.000,-0.200,0.000,-0.500,0.000,-0.866",
                "citizenM,5.562,0.000,1.528,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.286,0.296,1.007,-0.003,0.993,-0.035,-0.114"
            ]
        },
        {
            "time": 2.5160000324249269,
            "data": [
                "prisoner,-0.042,0.000,-0.196,0.000,-0.500,0.000,-0.866",
                "citizenM,5.555,0.000,1.527,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.286,0.296,1.009,-0.003,0.993,-0.035,-0.112"
            ]
        },
        {
            "time": 2.5290000438690187,
            "data": [
                "prisoner,-0.032,0.000,-0.191,0.000,-0.500,0.000,-0.866",
                "citizenM,5.543,0.000,1.527,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.279,0.296,1.005,-0.003,0.994,-0.035,-0.103"
            ]
        },
        {
            "time": 2.5439999103546144,
            "data": [
                "prisoner,-0.024,0.000,-0.185,0.000,-0.500,0.000,-0.866",
                "citizenM,5.532,0.000,1.526,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.274,0.296,1.001,-0.003,0.995,-0.035,-0.095"
            ]
        },
        {
            "time": 2.561000108718872,
            "data": [
                "prisoner,-0.014,0.000,-0.180,0.000,-0.500,0.000,-0.866",
                "citizenM,5.520,0.000,1.526,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.267,0.296,0.998,-0.002,0.996,-0.036,-0.086"
            ]
        },
        {
            "time": 2.572000026702881,
            "data": [
                "prisoner,-0.003,0.000,-0.173,0.000,-0.500,0.000,-0.866",
                "citizenM,5.507,0.000,1.525,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.260,0.296,0.993,-0.002,0.996,-0.036,-0.076"
            ]
        },
        {
            "time": 2.5859999656677248,
            "data": [
                "prisoner,0.005,0.000,-0.168,0.000,-0.500,0.000,-0.866",
                "citizenM,5.497,0.000,1.525,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.254,0.296,0.990,-0.002,0.997,-0.037,-0.069"
            ]
        },
        {
            "time": 2.6010000705718996,
            "data": [
                "prisoner,0.014,0.000,-0.163,0.000,-0.500,0.000,-0.866",
                "citizenM,5.486,0.000,1.524,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.248,0.296,0.986,-0.002,0.998,-0.037,-0.060"
            ]
        },
        {
            "time": 2.614000082015991,
            "data": [
                "prisoner,0.024,0.000,-0.157,0.000,-0.500,0.000,-0.866",
                "citizenM,5.475,0.000,1.523,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.242,0.296,0.983,-0.001,0.998,-0.038,-0.051"
            ]
        },
        {
            "time": 2.628000020980835,
            "data": [
                "prisoner,0.032,0.000,-0.152,0.000,-0.500,0.000,-0.866",
                "citizenM,5.464,0.000,1.523,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.236,0.296,0.979,-0.001,0.998,-0.038,-0.043"
            ]
        },
        {
            "time": 2.6410000324249269,
            "data": [
                "prisoner,0.042,0.000,-0.146,0.000,-0.500,0.000,-0.866",
                "citizenM,5.452,0.000,1.522,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.230,0.296,0.975,-0.001,0.999,-0.038,-0.034"
            ]
        },
        {
            "time": 2.6549999713897707,
            "data": [
                "prisoner,0.050,0.000,-0.141,0.000,-0.500,0.000,-0.866",
                "citizenM,5.442,0.000,1.522,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.224,0.296,0.972,0.000,0.999,-0.039,-0.027"
            ]
        },
        {
            "time": 2.6710000038146974,
            "data": [
                "prisoner,0.060,0.000,-0.135,0.000,-0.500,0.000,-0.866",
                "citizenM,5.431,0.000,1.521,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.218,0.296,0.968,0.000,0.999,-0.039,-0.018"
            ]
        },
        {
            "time": 2.684000015258789,
            "data": [
                "prisoner,0.071,0.000,-0.129,0.000,-0.500,0.000,-0.866",
                "citizenM,5.418,0.000,1.521,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.210,0.296,0.964,0.000,0.999,-0.039,-0.008"
            ]
        },
        {
            "time": 2.7130000591278078,
            "data": [
                "prisoner,0.079,0.000,-0.124,0.000,-0.500,0.000,-0.866",
                "citizenM,5.408,0.000,1.520,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.205,0.296,0.961,0.001,0.999,-0.040,0.000"
            ]
        },
        {
            "time": 2.7160000801086427,
            "data": [
                "prisoner,0.099,0.000,-0.112,0.000,-0.500,0.000,-0.866",
                "citizenM,5.385,0.000,1.519,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.192,0.296,0.953,0.001,0.999,-0.041,0.018"
            ]
        },
        {
            "time": 2.7260000705718996,
            "data": [
                "prisoner,0.100,0.000,-0.111,0.000,-0.500,0.000,-0.866",
                "citizenM,5.383,0.000,1.519,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.191,0.296,0.952,0.001,0.999,-0.041,0.019"
            ]
        },
        {
            "time": 2.743000030517578,
            "data": [
                "prisoner,0.107,0.000,-0.107,0.000,-0.500,0.000,-0.866",
                "citizenM,5.375,0.000,1.519,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.186,0.296,0.949,0.002,0.999,-0.041,0.026"
            ]
        },
        {
            "time": 2.75600004196167,
            "data": [
                "prisoner,0.118,0.000,-0.100,0.000,-0.500,0.000,-0.866",
                "citizenM,5.362,0.000,1.518,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.179,0.296,0.945,0.002,0.998,-0.041,0.036"
            ]
        },
        {
            "time": 2.7709999084472658,
            "data": [
                "prisoner,0.127,0.000,-0.095,0.000,-0.500,0.000,-0.866",
                "citizenM,5.352,0.000,1.517,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.173,0.296,0.942,0.002,0.998,-0.042,0.044"
            ]
        },
        {
            "time": 2.7909998893737795,
            "data": [
                "prisoner,0.137,0.000,-0.089,0.000,-0.500,0.000,-0.866",
                "citizenM,5.340,0.000,1.517,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.166,0.296,0.938,0.003,0.998,-0.042,0.053"
            ]
        },
        {
            "time": 2.812999963760376,
            "data": [
                "prisoner,0.150,0.000,-0.081,0.000,-0.500,0.000,-0.866",
                "citizenM,5.324,0.000,1.516,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.157,0.296,0.932,0.003,0.997,-0.043,0.065"
            ]
        },
        {
            "time": 2.815999984741211,
            "data": [
                "prisoner,0.165,0.000,-0.073,0.000,-0.500,0.000,-0.866",
                "citizenM,5.307,0.000,1.515,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.147,0.296,0.927,0.004,0.996,-0.043,0.079"
            ]
        },
        {
            "time": 2.8289999961853029,
            "data": [
                "prisoner,0.167,0.000,-0.071,0.000,-0.500,0.000,-0.866",
                "citizenM,5.305,0.000,1.515,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.146,0.296,0.926,0.004,0.996,-0.043,0.081"
            ]
        },
        {
            "time": 2.8440001010894777,
            "data": [
                "prisoner,0.176,0.000,-0.066,0.000,-0.500,0.000,-0.866",
                "citizenM,5.295,0.000,1.515,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.140,0.296,0.922,0.004,0.995,-0.044,0.088"
            ]
        },
        {
            "time": 2.8589999675750734,
            "data": [
                "prisoner,0.186,0.000,-0.060,0.000,-0.500,0.000,-0.866",
                "citizenM,5.283,0.000,1.514,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.134,0.296,0.918,0.005,0.994,-0.044,0.098"
            ]
        },
        {
            "time": 2.874000072479248,
            "data": [
                "prisoner,0.196,0.000,-0.054,0.000,-0.500,0.000,-0.866",
                "citizenM,5.272,0.000,1.514,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.127,0.296,0.914,0.005,0.993,-0.044,0.107"
            ]
        },
        {
            "time": 2.88700008392334,
            "data": [
                "prisoner,0.206,0.000,-0.048,0.000,-0.500,0.000,-0.866",
                "citizenM,5.260,0.000,1.513,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.120,0.296,0.910,0.006,0.992,-0.045,0.116"
            ]
        },
        {
            "time": 2.9030001163482668,
            "data": [
                "prisoner,0.215,0.000,-0.043,0.000,-0.500,0.000,-0.866",
                "citizenM,5.251,0.000,1.513,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.114,0.296,0.907,0.006,0.991,-0.045,0.124"
            ]
        },
        {
            "time": 2.9159998893737795,
            "data": [
                "prisoner,0.226,0.000,-0.037,0.000,-0.500,0.000,-0.866",
                "citizenM,5.238,0.000,1.512,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.107,0.296,0.903,0.007,0.990,-0.045,0.134"
            ]
        },
        {
            "time": 2.930999994277954,
            "data": [
                "prisoner,0.234,0.000,-0.031,0.000,-0.500,0.000,-0.866",
                "citizenM,5.229,0.000,1.511,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.101,0.296,0.899,0.007,0.989,-0.046,0.142"
            ]
        },
        {
            "time": 2.944000005722046,
            "data": [
                "prisoner,0.244,0.000,-0.026,0.000,-0.500,0.000,-0.866",
                "citizenM,5.218,0.000,1.511,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.095,0.296,0.895,0.008,0.988,-0.046,0.150"
            ]
        },
        {
            "time": 2.9570000171661379,
            "data": [
                "prisoner,0.253,0.000,-0.020,0.000,-0.500,0.000,-0.866",
                "citizenM,5.208,0.000,1.510,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.089,0.296,0.892,0.008,0.986,-0.046,0.158"
            ]
        },
        {
            "time": 2.9719998836517336,
            "data": [
                "prisoner,0.262,0.000,-0.015,0.000,-0.500,0.000,-0.866",
                "citizenM,5.198,0.000,1.510,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.083,0.296,0.888,0.008,0.985,-0.047,0.167"
            ]
        },
        {
            "time": 2.989000082015991,
            "data": [
                "prisoner,0.272,0.000,-0.009,0.000,-0.500,0.000,-0.866",
                "citizenM,5.187,0.000,1.509,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.076,0.296,0.884,0.009,0.983,-0.047,0.176"
            ]
        },
        {
            "time": 3.003999948501587,
            "data": [
                "prisoner,0.284,0.000,-0.002,0.000,-0.500,0.000,-0.866",
                "citizenM,5.174,0.000,1.509,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.069,0.296,0.880,0.010,0.981,-0.047,0.186"
            ]
        },
        {
            "time": 3.0179998874664308,
            "data": [
                "prisoner,0.294,0.000,0.004,0.000,-0.500,0.000,-0.866",
                "citizenM,5.163,0.000,1.508,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.062,0.296,0.876,0.010,0.980,-0.048,0.195"
            ]
        },
        {
            "time": 3.0369999408721926,
            "data": [
                "prisoner,0.303,0.000,0.009,0.000,-0.500,0.000,-0.866",
                "citizenM,5.153,0.000,1.508,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.056,0.296,0.872,0.011,0.978,-0.048,0.203"
            ]
        },
        {
            "time": 3.0460000038146974,
            "data": [
                "prisoner,0.316,0.000,0.017,0.000,-0.500,0.000,-0.866",
                "citizenM,5.140,0.000,1.507,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.048,0.296,0.867,0.011,0.976,-0.048,0.214"
            ]
        },
        {
            "time": 3.062000036239624,
            "data": [
                "prisoner,0.323,0.000,0.021,0.000,-0.500,0.000,-0.866",
                "citizenM,5.133,0.000,1.507,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.043,0.296,0.865,0.012,0.974,-0.048,0.220"
            ]
        },
        {
            "time": 3.075000047683716,
            "data": [
                "prisoner,0.333,0.000,0.027,0.000,-0.500,0.000,-0.866",
                "citizenM,5.122,0.000,1.506,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.037,0.296,0.861,0.012,0.972,-0.049,0.229"
            ]
        },
        {
            "time": 3.0920000076293947,
            "data": [
                "prisoner,0.342,0.000,0.032,0.000,-0.500,0.000,-0.866",
                "citizenM,5.112,0.000,1.506,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.030,0.296,0.857,0.013,0.970,-0.049,0.237"
            ]
        },
        {
            "time": 3.1080000400543215,
            "data": [
                "prisoner,0.354,0.000,0.039,0.000,-0.500,0.000,-0.866",
                "citizenM,5.100,0.000,1.505,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.023,0.296,0.853,0.013,0.968,-0.049,0.247"
            ]
        },
        {
            "time": 3.121999979019165,
            "data": [
                "prisoner,0.364,0.000,0.045,0.000,-0.500,0.000,-0.866",
                "citizenM,5.089,0.000,1.505,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.016,0.297,0.849,0.014,0.965,-0.050,0.257"
            ]
        },
        {
            "time": 3.13700008392334,
            "data": [
                "prisoner,0.374,0.000,0.051,0.000,-0.500,0.000,-0.866",
                "citizenM,5.079,0.000,1.504,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.010,0.297,0.845,0.014,0.963,-0.050,0.265"
            ]
        },
        {
            "time": 3.1519999504089357,
            "data": [
                "prisoner,0.384,0.000,0.057,0.000,-0.500,0.000,-0.866",
                "citizenM,5.068,0.000,1.504,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,0.003,0.297,0.841,0.015,0.960,-0.050,0.274"
            ]
        },
        {
            "time": 3.1670000553131105,
            "data": [
                "prisoner,0.394,0.000,0.063,0.000,-0.500,0.000,-0.866",
                "citizenM,5.058,0.000,1.503,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.004,0.297,0.837,0.015,0.958,-0.050,0.283"
            ]
        },
        {
            "time": 3.178999900817871,
            "data": [
                "prisoner,0.404,0.000,0.069,0.000,-0.500,0.000,-0.866",
                "citizenM,5.048,0.000,1.503,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.010,0.297,0.833,0.016,0.955,-0.051,0.291"
            ]
        },
        {
            "time": 3.194999933242798,
            "data": [
                "prisoner,0.413,0.000,0.074,0.000,-0.500,0.000,-0.866",
                "citizenM,5.039,0.000,1.502,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.016,0.297,0.830,0.017,0.953,-0.051,0.299"
            ]
        },
        {
            "time": 3.2119998931884767,
            "data": [
                "prisoner,0.424,0.000,0.080,0.000,-0.500,0.000,-0.866",
                "citizenM,5.029,0.000,1.502,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.023,0.297,0.826,0.017,0.950,-0.051,0.308"
            ]
        },
        {
            "time": 3.2279999256134035,
            "data": [
                "prisoner,0.435,0.000,0.087,0.000,-0.500,0.000,-0.866",
                "citizenM,5.017,0.000,1.501,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.030,0.297,0.821,0.018,0.947,-0.051,0.318"
            ]
        },
        {
            "time": 3.240999937057495,
            "data": [
                "prisoner,0.446,0.000,0.093,0.000,-0.500,0.000,-0.866",
                "citizenM,5.007,0.000,1.501,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.037,0.297,0.817,0.018,0.944,-0.051,0.327"
            ]
        },
        {
            "time": 3.255000114440918,
            "data": [
                "prisoner,0.455,0.000,0.098,0.000,-0.500,0.000,-0.866",
                "citizenM,4.998,0.000,1.500,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.043,0.297,0.813,0.019,0.941,-0.052,0.335"
            ]
        },
        {
            "time": 3.2690000534057619,
            "data": [
                "prisoner,0.464,0.000,0.104,0.000,-0.500,0.000,-0.866",
                "citizenM,4.989,0.000,1.500,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.049,0.297,0.810,0.020,0.938,-0.052,0.342"
            ]
        },
        {
            "time": 3.2839999198913576,
            "data": [
                "prisoner,0.474,0.000,0.109,0.000,-0.500,0.000,-0.866",
                "citizenM,4.979,0.000,1.499,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.056,0.297,0.806,0.020,0.935,-0.052,0.351"
            ]
        },
        {
            "time": 3.2990000247955324,
            "data": [
                "prisoner,0.485,0.000,0.115,0.000,-0.500,0.000,-0.866",
                "citizenM,4.970,0.000,1.499,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.062,0.297,0.802,0.021,0.932,-0.052,0.359"
            ]
        },
        {
            "time": 3.315999984741211,
            "data": [
                "prisoner,0.495,0.000,0.122,0.000,-0.500,0.000,-0.866",
                "citizenM,4.960,0.000,1.498,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.069,0.297,0.798,0.021,0.928,-0.052,0.368"
            ]
        },
        {
            "time": 3.3320000171661379,
            "data": [
                "prisoner,0.507,0.000,0.128,0.000,-0.500,0.000,-0.866",
                "citizenM,4.949,0.000,1.498,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.077,0.297,0.793,0.022,0.924,-0.053,0.377"
            ]
        },
        {
            "time": 3.3499999046325685,
            "data": [
                "prisoner,0.517,0.000,0.135,0.000,-0.500,0.000,-0.866",
                "citizenM,4.939,0.000,1.497,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,-0.084,0.297,0.789,0.023,0.921,-0.053,0.386"
            ]
        },
        {
            "time": 3.3589999675750734,
            "data": [
                "prisoner,0.530,0.000,0.142,0.000,-0.500,0.000,-0.866",
                "citizenM,4.928,0.000,1.497,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.584,0.293,1.691,0.039,0.772,-0.047,0.633"
            ]
        },
        {
            "time": 3.374000072479248,
            "data": [
                "prisoner,0.536,0.000,0.145,0.000,-0.500,0.000,-0.866",
                "citizenM,4.922,0.000,1.496,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.769,-0.047,0.636"
            ]
        },
        {
            "time": 3.38700008392334,
            "data": [
                "prisoner,0.546,0.000,0.151,0.000,-0.500,0.000,-0.866",
                "citizenM,4.912,0.000,1.496,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.770,-0.047,0.635"
            ]
        },
        {
            "time": 3.4019999504089357,
            "data": [
                "prisoner,0.555,0.000,0.157,0.000,-0.500,0.000,-0.866",
                "citizenM,4.905,0.000,1.496,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.770,-0.047,0.635"
            ]
        },
        {
            "time": 3.4179999828338625,
            "data": [
                "prisoner,0.565,0.000,0.163,0.000,-0.500,0.000,-0.866",
                "citizenM,4.896,0.000,1.495,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.770,-0.047,0.635"
            ]
        },
        {
            "time": 3.433000087738037,
            "data": [
                "prisoner,0.577,0.000,0.169,0.000,-0.500,0.000,-0.866",
                "citizenM,4.886,0.000,1.495,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.771,-0.047,0.634"
            ]
        },
        {
            "time": 3.4489998817443849,
            "data": [
                "prisoner,0.587,0.000,0.175,0.000,-0.500,0.000,-0.866",
                "citizenM,4.877,0.000,1.494,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.771,-0.047,0.634"
            ]
        },
        {
            "time": 3.4630000591278078,
            "data": [
                "prisoner,0.598,0.000,0.181,0.000,-0.500,0.000,-0.866",
                "citizenM,4.867,0.000,1.494,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.040,0.771,-0.047,0.633"
            ]
        },
        {
            "time": 3.4730000495910646,
            "data": [
                "prisoner,0.608,0.000,0.187,0.000,-0.500,0.000,-0.866",
                "citizenM,4.859,0.000,1.493,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.772,-0.047,0.633"
            ]
        },
        {
            "time": 3.48799991607666,
            "data": [
                "prisoner,0.614,0.000,0.191,0.000,-0.500,0.000,-0.866",
                "citizenM,4.853,0.000,1.493,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.772,-0.047,0.633"
            ]
        },
        {
            "time": 3.500999927520752,
            "data": [
                "prisoner,0.624,0.000,0.197,0.000,-0.500,0.000,-0.866",
                "citizenM,4.845,0.000,1.493,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.772,-0.047,0.632"
            ]
        },
        {
            "time": 3.5169999599456789,
            "data": [
                "prisoner,0.633,0.000,0.202,0.000,-0.500,0.000,-0.866",
                "citizenM,4.837,0.000,1.492,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.772,-0.047,0.632"
            ]
        },
        {
            "time": 3.5320000648498537,
            "data": [
                "prisoner,0.645,0.000,0.209,0.000,-0.500,0.000,-0.866",
                "citizenM,4.828,0.000,1.492,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.773,-0.047,0.632"
            ]
        },
        {
            "time": 3.5450000762939455,
            "data": [
                "prisoner,0.655,0.000,0.215,0.000,-0.500,0.000,-0.866",
                "citizenM,4.820,0.000,1.491,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.773,-0.047,0.631"
            ]
        },
        {
            "time": 3.562000036239624,
            "data": [
                "prisoner,0.664,0.000,0.220,0.000,-0.500,0.000,-0.866",
                "citizenM,4.813,0.000,1.491,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.773,-0.047,0.631"
            ]
        },
        {
            "time": 3.575000047683716,
            "data": [
                "prisoner,0.676,0.000,0.227,0.000,-0.500,0.000,-0.866",
                "citizenM,4.803,0.000,1.491,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.774,-0.047,0.630"
            ]
        },
        {
            "time": 3.5850000381469728,
            "data": [
                "prisoner,0.685,0.000,0.232,0.000,-0.500,0.000,-0.866",
                "citizenM,4.796,0.000,1.490,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.774,-0.047,0.630"
            ]
        },
        {
            "time": 3.5999999046325685,
            "data": [
                "prisoner,0.692,0.000,0.236,0.000,-0.500,0.000,-0.866",
                "citizenM,4.791,0.000,1.490,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.774,-0.047,0.630"
            ]
        },
        {
            "time": 3.617000102996826,
            "data": [
                "prisoner,0.702,0.000,0.242,0.000,-0.500,0.000,-0.866",
                "citizenM,4.783,0.000,1.490,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.775,-0.047,0.629"
            ]
        },
        {
            "time": 3.628999948501587,
            "data": [
                "prisoner,0.714,0.000,0.249,0.000,-0.500,0.000,-0.866",
                "citizenM,4.774,0.000,1.489,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.775,-0.047,0.629"
            ]
        },
        {
            "time": 3.6440000534057619,
            "data": [
                "prisoner,0.722,0.000,0.254,0.000,-0.500,0.000,-0.866",
                "citizenM,4.768,0.000,1.489,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.775,-0.048,0.629"
            ]
        },
        {
            "time": 3.6600000858306886,
            "data": [
                "prisoner,0.733,0.000,0.259,0.000,-0.500,0.000,-0.866",
                "citizenM,4.760,0.000,1.488,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.776,-0.048,0.628"
            ]
        },
        {
            "time": 3.6740000247955324,
            "data": [
                "prisoner,0.744,0.000,0.266,0.000,-0.500,0.000,-0.866",
                "citizenM,4.752,0.000,1.488,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.776,-0.048,0.628"
            ]
        },
        {
            "time": 3.686000108718872,
            "data": [
                "prisoner,0.754,0.000,0.272,0.000,-0.500,0.000,-0.866",
                "citizenM,4.745,0.000,1.488,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.776,-0.048,0.627"
            ]
        },
        {
            "time": 3.6989998817443849,
            "data": [
                "prisoner,0.762,0.000,0.276,0.000,-0.500,0.000,-0.866",
                "citizenM,4.739,0.000,1.487,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.776,-0.048,0.627"
            ]
        },
        {
            "time": 3.7139999866485597,
            "data": [
                "prisoner,0.771,0.000,0.282,0.000,-0.500,0.000,-0.866",
                "citizenM,4.733,0.000,1.487,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.777,-0.048,0.627"
            ]
        },
        {
            "time": 3.7290000915527345,
            "data": [
                "prisoner,0.781,0.000,0.287,0.000,-0.500,0.000,-0.866",
                "citizenM,4.726,0.000,1.487,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.777,-0.048,0.626"
            ]
        },
        {
            "time": 3.743000030517578,
            "data": [
                "prisoner,0.792,0.000,0.293,0.000,-0.500,0.000,-0.866",
                "citizenM,4.719,0.000,1.486,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.777,-0.048,0.626"
            ]
        },
        {
            "time": 3.759000062942505,
            "data": [
                "prisoner,0.802,0.000,0.299,0.000,-0.500,0.000,-0.866",
                "citizenM,4.712,0.000,1.486,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.778,-0.048,0.626"
            ]
        },
        {
            "time": 3.7720000743865969,
            "data": [
                "prisoner,0.812,0.000,0.305,0.000,-0.500,0.000,-0.866",
                "citizenM,4.705,0.000,1.486,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.778,-0.048,0.625"
            ]
        },
        {
            "time": 3.7860000133514406,
            "data": [
                "prisoner,0.822,0.000,0.311,0.000,-0.500,0.000,-0.866",
                "citizenM,4.699,0.000,1.485,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.778,-0.048,0.625"
            ]
        },
        {
            "time": 3.799999952316284,
            "data": [
                "prisoner,0.831,0.000,0.316,0.000,-0.500,0.000,-0.866",
                "citizenM,4.693,0.000,1.485,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.779,-0.048,0.624"
            ]
        },
        {
            "time": 3.811000108718872,
            "data": [
                "prisoner,0.841,0.000,0.322,0.000,-0.500,0.000,-0.866",
                "citizenM,4.687,0.000,1.485,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.779,-0.048,0.624"
            ]
        },
        {
            "time": 3.8259999752044679,
            "data": [
                "prisoner,0.849,0.000,0.326,0.000,-0.500,0.000,-0.866",
                "citizenM,4.682,0.000,1.485,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.779,-0.048,0.624"
            ]
        },
        {
            "time": 3.8410000801086427,
            "data": [
                "prisoner,0.859,0.000,0.332,0.000,-0.500,0.000,-0.866",
                "citizenM,4.676,0.000,1.484,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.779,-0.048,0.623"
            ]
        },
        {
            "time": 3.8570001125335695,
            "data": [
                "prisoner,0.870,0.000,0.338,0.000,-0.500,0.000,-0.866",
                "citizenM,4.670,0.000,1.484,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.780,-0.048,0.623"
            ]
        },
        {
            "time": 3.869999885559082,
            "data": [
                "prisoner,0.881,0.000,0.345,0.000,-0.500,0.000,-0.866",
                "citizenM,4.663,0.000,1.484,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.780,-0.048,0.623"
            ]
        },
        {
            "time": 3.884999990463257,
            "data": [
                "prisoner,0.890,0.000,0.350,0.000,-0.500,0.000,-0.866",
                "citizenM,4.658,0.000,1.483,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.780,-0.048,0.622"
            ]
        },
        {
            "time": 3.8980000019073488,
            "data": [
                "prisoner,0.901,0.000,0.356,0.000,-0.500,0.000,-0.866",
                "citizenM,4.652,0.000,1.483,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.781,-0.048,0.622"
            ]
        },
        {
            "time": 3.9119999408721926,
            "data": [
                "prisoner,0.910,0.000,0.361,0.000,-0.500,0.000,-0.866",
                "citizenM,4.647,0.000,1.483,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.781,-0.048,0.621"
            ]
        },
        {
            "time": 3.9240000247955324,
            "data": [
                "prisoner,0.919,0.000,0.367,0.000,-0.500,0.000,-0.866",
                "citizenM,4.642,0.000,1.483,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.781,-0.048,0.621"
            ]
        },
        {
            "time": 3.940000057220459,
            "data": [
                "prisoner,0.927,0.000,0.372,0.000,-0.500,0.000,-0.866",
                "citizenM,4.637,0.000,1.482,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.782,-0.048,0.621"
            ]
        },
        {
            "time": 3.9549999237060549,
            "data": [
                "prisoner,0.939,0.000,0.378,0.000,-0.500,0.000,-0.866",
                "citizenM,4.631,0.000,1.482,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.782,-0.048,0.620"
            ]
        },
        {
            "time": 3.9700000286102297,
            "data": [
                "prisoner,0.949,0.000,0.384,0.000,-0.500,0.000,-0.866",
                "citizenM,4.626,0.000,1.482,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.782,-0.048,0.620"
            ]
        },
        {
            "time": 3.9830000400543215,
            "data": [
                "prisoner,0.959,0.000,0.390,0.000,-0.500,0.000,-0.866",
                "citizenM,4.621,0.000,1.482,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.783,-0.049,0.619"
            ]
        },
        {
            "time": 3.996999979019165,
            "data": [
                "prisoner,0.969,0.000,0.395,0.000,-0.500,0.000,-0.866",
                "citizenM,4.616,0.000,1.481,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.783,-0.049,0.619"
            ]
        },
        {
            "time": 4.010000228881836,
            "data": [
                "prisoner,0.979,0.000,0.401,0.000,-0.500,0.000,-0.866",
                "citizenM,4.612,0.000,1.481,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.783,-0.049,0.619"
            ]
        },
        {
            "time": 4.0269999504089359,
            "data": [
                "prisoner,0.988,0.000,0.406,0.000,-0.500,0.000,-0.866",
                "citizenM,4.607,0.000,1.481,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.783,-0.049,0.618"
            ]
        },
        {
            "time": 4.034999847412109,
            "data": [
                "prisoner,1.000,0.000,0.413,0.000,-0.500,0.000,-0.866",
                "citizenM,4.602,0.000,1.481,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.784,-0.049,0.618"
            ]
        },
        {
            "time": 4.050000190734863,
            "data": [
                "prisoner,1.005,0.000,0.416,0.000,-0.500,0.000,-0.866",
                "citizenM,4.600,0.000,1.481,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.784,-0.049,0.618"
            ]
        },
        {
            "time": 4.065000057220459,
            "data": [
                "prisoner,1.016,0.000,0.422,0.000,-0.500,0.000,-0.866",
                "citizenM,4.595,0.000,1.480,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.784,-0.049,0.617"
            ]
        },
        {
            "time": 4.078999996185303,
            "data": [
                "prisoner,1.026,0.000,0.428,0.000,-0.500,0.000,-0.866",
                "citizenM,4.591,0.000,1.480,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.785,-0.049,0.617"
            ]
        },
        {
            "time": 4.0960001945495609,
            "data": [
                "prisoner,1.036,0.000,0.434,0.000,-0.500,0.000,-0.866",
                "citizenM,4.587,0.000,1.480,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.785,-0.049,0.617"
            ]
        },
        {
            "time": 4.107999801635742,
            "data": [
                "prisoner,1.048,0.000,0.441,0.000,-0.500,0.000,-0.866",
                "citizenM,4.582,0.000,1.480,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.785,-0.049,0.616"
            ]
        },
        {
            "time": 4.125999927520752,
            "data": [
                "prisoner,1.057,0.000,0.446,0.000,-0.500,0.000,-0.866",
                "citizenM,4.579,0.000,1.480,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.785,-0.049,0.616"
            ]
        },
        {
            "time": 4.139999866485596,
            "data": [
                "prisoner,1.069,0.000,0.453,0.000,-0.500,0.000,-0.866",
                "citizenM,4.574,0.000,1.479,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.786,-0.049,0.615"
            ]
        },
        {
            "time": 4.1479997634887699,
            "data": [
                "prisoner,1.079,0.000,0.458,0.000,-0.500,0.000,-0.866",
                "citizenM,4.571,0.000,1.479,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.786,-0.049,0.615"
            ]
        },
        {
            "time": 4.164000034332275,
            "data": [
                "prisoner,1.084,0.000,0.461,0.000,-0.500,0.000,-0.866",
                "citizenM,4.569,0.000,1.479,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.786,-0.049,0.615"
            ]
        },
        {
            "time": 4.177000045776367,
            "data": [
                "prisoner,1.096,0.000,0.468,0.000,-0.500,0.000,-0.866",
                "citizenM,4.565,0.000,1.479,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.787,-0.049,0.614"
            ]
        },
        {
            "time": 4.192999839782715,
            "data": [
                "prisoner,1.105,0.000,0.473,0.000,-0.500,0.000,-0.866",
                "citizenM,4.562,0.000,1.479,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.787,-0.049,0.614"
            ]
        },
        {
            "time": 4.208000183105469,
            "data": [
                "prisoner,1.116,0.000,0.480,0.000,-0.500,0.000,-0.866",
                "citizenM,4.559,0.000,1.479,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.787,-0.049,0.613"
            ]
        },
        {
            "time": 4.2210001945495609,
            "data": [
                "prisoner,1.127,0.000,0.486,0.000,-0.500,0.000,-0.866",
                "citizenM,4.556,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.788,-0.049,0.613"
            ]
        },
        {
            "time": 4.235000133514404,
            "data": [
                "prisoner,1.136,0.000,0.491,0.000,-0.500,0.000,-0.866",
                "citizenM,4.553,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.788,-0.049,0.613"
            ]
        },
        {
            "time": 4.25,
            "data": [
                "prisoner,1.145,0.000,0.496,0.000,-0.500,0.000,-0.866",
                "citizenM,4.551,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.788,-0.049,0.612"
            ]
        },
        {
            "time": 4.260000228881836,
            "data": [
                "prisoner,1.156,0.000,0.502,0.000,-0.500,0.000,-0.866",
                "citizenM,4.548,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.788,-0.049,0.612"
            ]
        },
        {
            "time": 4.2769999504089359,
            "data": [
                "prisoner,1.163,0.000,0.506,0.000,-0.500,0.000,-0.866",
                "citizenM,4.546,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.789,-0.049,0.612"
            ]
        },
        {
            "time": 4.291999816894531,
            "data": [
                "prisoner,1.175,0.000,0.513,0.000,-0.500,0.000,-0.866",
                "citizenM,4.544,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.789,-0.049,0.611"
            ]
        },
        {
            "time": 4.303999900817871,
            "data": [
                "prisoner,1.186,0.000,0.519,0.000,-0.500,0.000,-0.866",
                "citizenM,4.541,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.789,-0.049,0.611"
            ]
        },
        {
            "time": 4.317999839782715,
            "data": [
                "prisoner,1.194,0.000,0.524,0.000,-0.500,0.000,-0.866",
                "citizenM,4.540,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.790,-0.050,0.610"
            ]
        },
        {
            "time": 4.335000038146973,
            "data": [
                "prisoner,1.204,0.000,0.530,0.000,-0.500,0.000,-0.866",
                "citizenM,4.538,0.000,1.478,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.790,-0.050,0.610"
            ]
        },
        {
            "time": 4.35099983215332,
            "data": [
                "prisoner,1.216,0.000,0.537,0.000,-0.500,0.000,-0.866",
                "citizenM,4.536,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.790,-0.050,0.610"
            ]
        },
        {
            "time": 4.359000205993652,
            "data": [
                "prisoner,1.227,0.000,0.543,0.000,-0.500,0.000,-0.866",
                "citizenM,4.534,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.791,-0.050,0.609"
            ]
        },
        {
            "time": 4.374000072479248,
            "data": [
                "prisoner,1.233,0.000,0.546,0.000,-0.500,0.000,-0.866",
                "citizenM,4.533,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.791,-0.050,0.609"
            ]
        },
        {
            "time": 4.388000011444092,
            "data": [
                "prisoner,1.243,0.000,0.552,0.000,-0.500,0.000,-0.866",
                "citizenM,4.532,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.791,-0.050,0.608"
            ]
        },
        {
            "time": 4.401000022888184,
            "data": [
                "prisoner,1.253,0.000,0.558,0.000,-0.500,0.000,-0.866",
                "citizenM,4.530,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.791,-0.050,0.608"
            ]
        },
        {
            "time": 4.416999816894531,
            "data": [
                "prisoner,1.262,0.000,0.563,0.000,-0.500,0.000,-0.866",
                "citizenM,4.530,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.792,-0.050,0.608"
            ]
        },
        {
            "time": 4.431000232696533,
            "data": [
                "prisoner,1.274,0.000,0.570,0.000,-0.500,0.000,-0.866",
                "citizenM,4.528,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.792,-0.050,0.607"
            ]
        },
        {
            "time": 4.443999767303467,
            "data": [
                "prisoner,1.283,0.000,0.575,0.000,-0.500,0.000,-0.866",
                "citizenM,4.528,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.792,-0.050,0.607"
            ]
        },
        {
            "time": 4.461999893188477,
            "data": [
                "prisoner,1.293,0.000,0.581,0.000,-0.500,0.000,-0.866",
                "citizenM,4.527,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.793,-0.050,0.607"
            ]
        },
        {
            "time": 4.46999979019165,
            "data": [
                "prisoner,1.305,0.000,0.587,0.000,-0.500,0.000,-0.866",
                "citizenM,4.527,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.793,-0.050,0.606"
            ]
        },
        {
            "time": 4.485000133514404,
            "data": [
                "prisoner,1.311,0.000,0.591,0.000,-0.500,0.000,-0.866",
                "citizenM,4.526,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.793,-0.050,0.606"
            ]
        },
        {
            "time": 4.499000072479248,
            "data": [
                "prisoner,1.321,0.000,0.597,0.000,-0.500,0.000,-0.866",
                "citizenM,4.526,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.793,-0.050,0.605"
            ]
        },
        {
            "time": 4.513999938964844,
            "data": [
                "prisoner,1.331,0.000,0.603,0.000,-0.500,0.000,-0.866",
                "citizenM,4.526,0.000,1.477,0.000,-0.707,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.794,-0.050,0.605"
            ]
        },
        {
            "time": 4.526000022888184,
            "data": [
                "prisoner,1.342,0.000,0.608,0.000,-0.500,0.000,-0.866",
                "citizenM,4.526,0.000,1.477,0.000,-0.708,0.000,0.707",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.794,-0.050,0.604"
            ]
        },
        {
            "time": 4.541999816894531,
            "data": [
                "prisoner,1.351,0.000,0.613,0.000,-0.500,0.000,-0.866",
                "citizenM,4.527,0.000,1.477,0.000,-0.709,0.000,0.706",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.795,-0.050,0.603"
            ]
        },
        {
            "time": 4.556000232696533,
            "data": [
                "prisoner,1.362,0.000,0.620,0.000,-0.500,0.000,-0.866",
                "citizenM,4.528,0.000,1.477,0.000,-0.711,0.000,0.703",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.796,-0.050,0.602"
            ]
        },
        {
            "time": 4.568999767303467,
            "data": [
                "prisoner,1.372,0.000,0.625,0.000,-0.500,0.000,-0.866",
                "citizenM,4.529,0.000,1.477,0.000,-0.714,0.000,0.701",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.796,-0.050,0.601"
            ]
        },
        {
            "time": 4.581999778747559,
            "data": [
                "prisoner,1.380,0.000,0.630,0.000,-0.500,0.000,-0.866",
                "citizenM,4.531,0.000,1.477,0.000,-0.717,0.000,0.697",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.797,-0.050,0.600"
            ]
        },
        {
            "time": 4.5970001220703129,
            "data": [
                "prisoner,1.390,0.000,0.636,0.000,-0.500,0.000,-0.866",
                "citizenM,4.533,0.000,1.477,0.000,-0.720,0.000,0.694",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.798,-0.050,0.600"
            ]
        },
        {
            "time": 4.611000061035156,
            "data": [
                "prisoner,1.400,0.000,0.642,0.000,-0.500,0.000,-0.866",
                "citizenM,4.536,0.000,1.477,0.000,-0.725,0.000,0.688",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.798,-0.051,0.599"
            ]
        },
        {
            "time": 4.625,
            "data": [
                "prisoner,1.410,0.000,0.648,0.000,-0.500,0.000,-0.866",
                "citizenM,4.539,0.000,1.478,0.000,-0.731,0.000,0.682",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.799,-0.051,0.598"
            ]
        },
        {
            "time": 4.639999866485596,
            "data": [
                "prisoner,1.420,0.000,0.653,0.000,-0.500,0.000,-0.866",
                "citizenM,4.542,0.000,1.478,0.000,-0.737,0.000,0.676",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.800,-0.051,0.597"
            ]
        },
        {
            "time": 4.65500020980835,
            "data": [
                "prisoner,1.431,0.000,0.659,0.000,-0.500,0.000,-0.866",
                "citizenM,4.546,0.000,1.478,0.000,-0.744,0.000,0.669",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.801,-0.051,0.596"
            ]
        },
        {
            "time": 4.665999889373779,
            "data": [
                "prisoner,1.441,0.000,0.665,0.000,-0.500,0.000,-0.866",
                "citizenM,4.550,0.000,1.478,0.000,-0.751,0.000,0.661",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.801,-0.051,0.595"
            ]
        },
        {
            "time": 4.681000232696533,
            "data": [
                "prisoner,1.449,0.000,0.670,0.000,-0.500,0.000,-0.866",
                "citizenM,4.553,0.000,1.478,0.000,-0.757,0.000,0.654",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.802,-0.051,0.594"
            ]
        },
        {
            "time": 4.692999839782715,
            "data": [
                "prisoner,1.460,0.000,0.676,0.000,-0.500,0.000,-0.866",
                "citizenM,4.558,0.000,1.478,0.000,-0.765,0.000,0.644",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.039,0.803,-0.051,0.593"
            ]
        },
        {
            "time": 4.706999778747559,
            "data": [
                "prisoner,1.468,0.000,0.680,0.000,-0.500,0.000,-0.866",
                "citizenM,4.562,0.000,1.478,0.000,-0.772,0.000,0.636",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.803,-0.051,0.592"
            ]
        },
        {
            "time": 4.7220001220703129,
            "data": [
                "prisoner,1.478,0.000,0.686,0.000,-0.500,0.000,-0.866",
                "citizenM,4.567,0.000,1.479,0.000,-0.780,0.000,0.626",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.804,-0.051,0.591"
            ]
        },
        {
            "time": 4.73799991607666,
            "data": [
                "prisoner,1.489,0.000,0.692,0.000,-0.500,0.000,-0.866",
                "citizenM,4.573,0.000,1.479,0.000,-0.789,0.000,0.614",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.805,-0.051,0.590"
            ]
        },
        {
            "time": 4.750999927520752,
            "data": [
                "prisoner,1.500,0.000,0.698,0.000,-0.500,0.000,-0.866",
                "citizenM,4.579,0.000,1.479,0.000,-0.799,0.000,0.602",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.805,-0.051,0.589"
            ]
        },
        {
            "time": 4.76200008392334,
            "data": [
                "prisoner,1.509,0.000,0.704,0.000,-0.500,0.000,-0.866",
                "citizenM,4.584,0.000,1.479,0.000,-0.807,0.000,0.590",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.806,-0.051,0.588"
            ]
        },
        {
            "time": 4.7789998054504398,
            "data": [
                "prisoner,1.517,0.000,0.708,0.000,-0.500,0.000,-0.866",
                "citizenM,4.589,0.000,1.480,0.000,-0.815,0.000,0.580",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.807,-0.051,0.588"
            ]
        },
        {
            "time": 4.793000221252441,
            "data": [
                "prisoner,1.528,0.000,0.715,0.000,-0.500,0.000,-0.866",
                "citizenM,4.596,0.000,1.480,0.000,-0.825,0.000,0.565",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.807,-0.051,0.586"
            ]
        },
        {
            "time": 4.803999900817871,
            "data": [
                "prisoner,1.539,0.000,0.721,0.000,-0.500,0.000,-0.866",
                "citizenM,4.602,0.000,1.480,0.000,-0.835,0.000,0.551",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.808,-0.051,0.585"
            ]
        },
        {
            "time": 4.818999767303467,
            "data": [
                "prisoner,1.546,0.000,0.725,0.000,-0.500,0.000,-0.866",
                "citizenM,4.607,0.000,1.480,0.000,-0.842,0.000,0.540",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.809,-0.051,0.585"
            ]
        },
        {
            "time": 4.830999851226807,
            "data": [
                "prisoner,1.557,0.000,0.731,0.000,-0.500,0.000,-0.866",
                "citizenM,4.614,0.000,1.481,0.000,-0.851,0.000,0.525",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.809,-0.052,0.584"
            ]
        },
        {
            "time": 4.8470001220703129,
            "data": [
                "prisoner,1.565,0.000,0.736,0.000,-0.500,0.000,-0.866",
                "citizenM,4.619,0.000,1.481,0.000,-0.859,0.000,0.512",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.810,-0.052,0.583"
            ]
        },
        {
            "time": 4.861999988555908,
            "data": [
                "prisoner,1.577,0.000,0.742,0.000,-0.500,0.000,-0.866",
                "citizenM,4.627,0.000,1.481,0.000,-0.870,0.000,0.494",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.811,-0.052,0.582"
            ]
        },
        {
            "time": 4.875999927520752,
            "data": [
                "prisoner,1.588,0.000,0.748,0.000,-0.500,0.000,-0.866",
                "citizenM,4.634,0.000,1.481,0.000,-0.879,0.000,0.477",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.812,-0.052,0.581"
            ]
        },
        {
            "time": 4.889999866485596,
            "data": [
                "prisoner,1.597,0.000,0.754,0.000,-0.500,0.000,-0.866",
                "citizenM,4.641,0.000,1.482,0.000,-0.887,0.000,0.461",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.812,-0.052,0.580"
            ]
        },
        {
            "time": 4.906000137329102,
            "data": [
                "prisoner,1.607,0.000,0.759,0.000,-0.500,0.000,-0.866",
                "citizenM,4.648,0.000,1.482,0.000,-0.895,0.000,0.445",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.813,-0.052,0.579"
            ]
        },
        {
            "time": 4.914999961853027,
            "data": [
                "prisoner,1.619,0.000,0.766,0.000,-0.500,0.000,-0.866",
                "citizenM,4.656,0.000,1.482,0.000,-0.905,0.000,0.426",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.814,-0.052,0.578"
            ]
        },
        {
            "time": 4.928999900817871,
            "data": [
                "prisoner,1.625,0.000,0.770,0.000,-0.500,0.000,-0.866",
                "citizenM,4.660,0.000,1.482,0.000,-0.910,0.000,0.415",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.814,-0.052,0.577"
            ]
        },
        {
            "time": 4.941999912261963,
            "data": [
                "prisoner,1.635,0.000,0.775,0.000,-0.500,0.000,-0.866",
                "citizenM,4.667,0.000,1.483,0.000,-0.917,0.000,0.398",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.815,-0.052,0.576"
            ]
        },
        {
            "time": 4.958000183105469,
            "data": [
                "prisoner,1.644,0.000,0.780,0.000,-0.500,0.000,-0.866",
                "citizenM,4.674,0.000,1.483,0.000,-0.924,0.000,0.382",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.815,-0.052,0.575"
            ]
        },
        {
            "time": 4.9720001220703129,
            "data": [
                "prisoner,1.655,0.000,0.787,0.000,-0.500,0.000,-0.866",
                "citizenM,4.682,0.000,1.483,0.000,-0.932,0.000,0.362",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.816,-0.052,0.574"
            ]
        },
        {
            "time": 4.986000061035156,
            "data": [
                "prisoner,1.665,0.000,0.793,0.000,-0.500,0.000,-0.866",
                "citizenM,4.689,0.000,1.484,0.000,-0.939,0.000,0.345",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.038,0.817,-0.052,0.573"
            ]
        },
        {
            "time": 5.0,
            "data": [
                "prisoner,1.675,0.000,0.798,0.000,-0.500,0.000,-0.866",
                "citizenM,4.696,0.000,1.484,0.000,-0.945,0.000,0.327",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.817,-0.052,0.572"
            ]
        },
        {
            "time": 5.013999938964844,
            "data": [
                "prisoner,1.685,0.000,0.804,0.000,-0.500,0.000,-0.866",
                "citizenM,4.703,0.000,1.484,0.000,-0.951,0.000,0.310",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.818,-0.052,0.571"
            ]
        },
        {
            "time": 5.03000020980835,
            "data": [
                "prisoner,1.695,0.000,0.809,0.000,-0.500,0.000,-0.866",
                "citizenM,4.710,0.000,1.484,0.000,-0.956,0.000,0.292",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.819,-0.052,0.570"
            ]
        },
        {
            "time": 5.038000106811523,
            "data": [
                "prisoner,1.706,0.000,0.816,0.000,-0.500,0.000,-0.866",
                "citizenM,4.717,0.000,1.485,0.000,-0.962,0.000,0.272",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.820,-0.052,0.569"
            ]
        },
        {
            "time": 5.052999973297119,
            "data": [
                "prisoner,1.712,0.000,0.819,0.000,-0.500,0.000,-0.866",
                "citizenM,4.721,0.000,1.485,0.000,-0.965,0.000,0.263",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.820,-0.053,0.569"
            ]
        },
        {
            "time": 5.068999767303467,
            "data": [
                "prisoner,1.722,0.000,0.825,0.000,-0.500,0.000,-0.866",
                "citizenM,4.728,0.000,1.485,0.000,-0.969,0.000,0.245",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.821,-0.053,0.568"
            ]
        },
        {
            "time": 5.084000110626221,
            "data": [
                "prisoner,1.733,0.000,0.831,0.000,-0.500,0.000,-0.866",
                "citizenM,4.736,0.000,1.486,0.000,-0.974,0.000,0.226",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.821,-0.053,0.567"
            ]
        },
        {
            "time": 5.0960001945495609,
            "data": [
                "prisoner,1.744,0.000,0.837,0.000,-0.500,0.000,-0.866",
                "citizenM,4.742,0.000,1.486,0.000,-0.978,0.000,0.208",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.822,-0.053,0.566"
            ]
        },
        {
            "time": 5.111000061035156,
            "data": [
                "prisoner,1.752,0.000,0.842,0.000,-0.500,0.000,-0.866",
                "citizenM,4.748,0.000,1.486,0.000,-0.981,0.000,0.194",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.823,-0.053,0.565"
            ]
        },
        {
            "time": 5.129000186920166,
            "data": [
                "prisoner,1.763,0.000,0.848,0.000,-0.500,0.000,-0.866",
                "citizenM,4.754,0.000,1.486,0.000,-0.984,0.000,0.177",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.823,-0.053,0.564"
            ]
        },
        {
            "time": 5.142000198364258,
            "data": [
                "prisoner,1.775,0.000,0.855,0.000,-0.500,0.000,-0.866",
                "citizenM,4.762,0.000,1.487,0.000,-0.988,0.000,0.158",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.824,-0.053,0.563"
            ]
        },
        {
            "time": 5.151000022888184,
            "data": [
                "prisoner,1.785,0.000,0.861,0.000,-0.500,0.000,-0.866",
                "citizenM,4.767,0.000,1.487,0.000,-0.990,0.000,0.143",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.825,-0.053,0.562"
            ]
        },
        {
            "time": 5.164999961853027,
            "data": [
                "prisoner,1.791,0.000,0.864,0.000,-0.500,0.000,-0.866",
                "citizenM,4.771,0.000,1.487,0.000,-0.991,0.000,0.134",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.825,-0.053,0.561"
            ]
        },
        {
            "time": 5.182000160217285,
            "data": [
                "prisoner,1.801,0.000,0.870,0.000,-0.500,0.000,-0.866",
                "citizenM,4.776,0.000,1.487,0.000,-0.993,0.000,0.120",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.826,-0.053,0.560"
            ]
        },
        {
            "time": 5.195000171661377,
            "data": [
                "prisoner,1.813,0.000,0.877,0.000,-0.500,0.000,-0.866",
                "citizenM,4.782,0.000,1.487,0.000,-0.995,0.000,0.104",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.827,-0.053,0.559"
            ]
        },
        {
            "time": 5.210000038146973,
            "data": [
                "prisoner,1.822,0.000,0.882,0.000,-0.500,0.000,-0.866",
                "citizenM,4.786,0.000,1.488,0.000,-0.996,0.000,0.092",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.827,-0.053,0.558"
            ]
        },
        {
            "time": 5.223999977111816,
            "data": [
                "prisoner,1.833,0.000,0.888,0.000,-0.500,0.000,-0.866",
                "citizenM,4.791,0.000,1.488,0.000,-0.997,0.000,0.079",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.828,-0.053,0.557"
            ]
        },
        {
            "time": 5.239999771118164,
            "data": [
                "prisoner,1.843,0.000,0.894,0.000,-0.500,0.000,-0.866",
                "citizenM,4.796,0.000,1.488,0.000,-0.998,0.000,0.067",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.829,-0.053,0.556"
            ]
        },
        {
            "time": 5.252999782562256,
            "data": [
                "prisoner,1.854,0.000,0.900,0.000,-0.500,0.000,-0.866",
                "citizenM,4.800,0.000,1.488,0.000,-0.998,0.000,0.055",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.829,-0.053,0.555"
            ]
        },
        {
            "time": 5.263999938964844,
            "data": [
                "prisoner,1.863,0.000,0.905,0.000,-0.500,0.000,-0.866",
                "citizenM,4.804,0.000,1.488,0.000,-0.999,0.000,0.046",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.830,-0.053,0.554"
            ]
        },
        {
            "time": 5.2769999504089359,
            "data": [
                "prisoner,1.871,0.000,0.910,0.000,-0.500,0.000,-0.866",
                "citizenM,4.806,0.000,1.488,0.000,-0.999,0.000,0.039",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.037,0.830,-0.054,0.553"
            ]
        },
        {
            "time": 5.293000221252441,
            "data": [
                "prisoner,1.880,0.000,0.915,0.000,-0.500,0.000,-0.866",
                "citizenM,4.809,0.000,1.489,0.000,-1.000,0.000,0.031",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.831,-0.054,0.552"
            ]
        },
        {
            "time": 5.307000160217285,
            "data": [
                "prisoner,1.892,0.000,0.922,0.000,-0.500,0.000,-0.866",
                "citizenM,4.812,0.000,1.489,0.000,-1.000,0.000,0.023",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.832,-0.054,0.551"
            ]
        },
        {
            "time": 5.321000099182129,
            "data": [
                "prisoner,1.901,0.000,0.927,0.000,-0.500,0.000,-0.866",
                "citizenM,4.815,0.000,1.489,0.000,-1.000,0.000,0.017",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.832,-0.054,0.550"
            ]
        },
        {
            "time": 5.335000038146973,
            "data": [
                "prisoner,1.911,0.000,0.933,0.000,-0.500,0.000,-0.866",
                "citizenM,4.817,0.000,1.489,0.000,-1.000,0.000,0.011",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.833,-0.054,0.549"
            ]
        },
        {
            "time": 5.349999904632568,
            "data": [
                "prisoner,1.921,0.000,0.938,0.000,-0.500,0.000,-0.866",
                "citizenM,4.818,0.000,1.489,0.000,-1.000,0.000,0.007",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.834,-0.054,0.548"
            ]
        },
        {
            "time": 5.366000175476074,
            "data": [
                "prisoner,1.931,0.000,0.944,0.000,-0.500,0.000,-0.866",
                "citizenM,4.820,0.000,1.489,0.000,-1.000,0.000,0.003",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.834,-0.054,0.547"
            ]
        },
        {
            "time": 5.374000072479248,
            "data": [
                "prisoner,1.942,0.000,0.950,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.489,0.000,-1.000,0.000,0.001",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.835,-0.054,0.546"
            ]
        },
        {
            "time": 5.388999938964844,
            "data": [
                "prisoner,1.948,0.000,0.954,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.489,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.835,-0.054,0.546"
            ]
        },
        {
            "time": 5.4039998054504398,
            "data": [
                "prisoner,1.959,0.000,0.960,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.489,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.836,-0.054,0.545"
            ]
        },
        {
            "time": 5.419000148773193,
            "data": [
                "prisoner,1.970,0.000,0.966,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.487,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.837,-0.054,0.544"
            ]
        },
        {
            "time": 5.434000015258789,
            "data": [
                "prisoner,1.980,0.000,0.972,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.483,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.837,-0.054,0.543"
            ]
        },
        {
            "time": 5.447000026702881,
            "data": [
                "prisoner,1.990,0.000,0.978,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.478,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.838,-0.054,0.542"
            ]
        },
        {
            "time": 5.464000225067139,
            "data": [
                "prisoner,2.000,0.000,0.983,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.472,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.839,-0.054,0.541"
            ]
        },
        {
            "time": 5.480999946594238,
            "data": [
                "prisoner,2.012,0.000,0.990,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.462,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.840,-0.054,0.539"
            ]
        },
        {
            "time": 5.500999927520752,
            "data": [
                "prisoner,2.023,0.000,0.997,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.450,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.840,-0.054,0.538"
            ]
        },
        {
            "time": 5.520999908447266,
            "data": [
                "prisoner,2.037,0.000,1.005,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.434,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.841,-0.055,0.537"
            ]
        },
        {
            "time": 5.541999816894531,
            "data": [
                "prisoner,2.051,0.000,1.013,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.415,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.842,-0.055,0.535"
            ]
        },
        {
            "time": 5.559999942779541,
            "data": [
                "prisoner,2.066,0.000,1.021,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.394,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.036,0.843,-0.055,0.534"
            ]
        },
        {
            "time": 5.580999851226807,
            "data": [
                "prisoner,2.079,0.000,1.029,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.373,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.844,-0.055,0.533"
            ]
        },
        {
            "time": 5.5960001945495609,
            "data": [
                "prisoner,2.094,0.000,1.037,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.348,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.845,-0.055,0.531"
            ]
        },
        {
            "time": 5.610000133514404,
            "data": [
                "prisoner,2.104,0.000,1.043,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.330,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.845,-0.055,0.530"
            ]
        },
        {
            "time": 5.626999855041504,
            "data": [
                "prisoner,2.114,0.000,1.049,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.311,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.846,-0.055,0.529"
            ]
        },
        {
            "time": 5.644000053405762,
            "data": [
                "prisoner,2.126,0.000,1.056,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.288,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.847,-0.055,0.528"
            ]
        },
        {
            "time": 5.659999847412109,
            "data": [
                "prisoner,2.138,0.000,1.062,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.265,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.847,-0.055,0.527"
            ]
        },
        {
            "time": 5.679999828338623,
            "data": [
                "prisoner,2.149,0.000,1.069,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.242,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.848,-0.055,0.526"
            ]
        },
        {
            "time": 5.691999912261963,
            "data": [
                "prisoner,2.163,0.000,1.077,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.215,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.849,-0.055,0.524"
            ]
        },
        {
            "time": 5.703999996185303,
            "data": [
                "prisoner,2.172,0.000,1.082,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.197,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.850,-0.055,0.523"
            ]
        },
        {
            "time": 5.71999979019165,
            "data": [
                "prisoner,2.180,0.000,1.086,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.181,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.850,-0.055,0.523"
            ]
        },
        {
            "time": 5.735000133514404,
            "data": [
                "prisoner,2.191,0.000,1.093,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.159,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.851,-0.055,0.521"
            ]
        },
        {
            "time": 5.751999855041504,
            "data": [
                "prisoner,2.202,0.000,1.099,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.137,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.851,-0.056,0.520"
            ]
        },
        {
            "time": 5.769000053405762,
            "data": [
                "prisoner,2.213,0.000,1.106,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.114,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.852,-0.056,0.519"
            ]
        },
        {
            "time": 5.785999774932861,
            "data": [
                "prisoner,2.225,0.000,1.112,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.092,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.853,-0.056,0.518"
            ]
        },
        {
            "time": 5.797999858856201,
            "data": [
                "prisoner,2.237,0.000,1.119,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.069,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.854,-0.056,0.517"
            ]
        },
        {
            "time": 5.809999942779541,
            "data": [
                "prisoner,2.245,0.000,1.124,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.054,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.035,0.854,-0.056,0.516"
            ]
        },
        {
            "time": 5.828999996185303,
            "data": [
                "prisoner,2.254,0.000,1.129,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.040,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.855,-0.056,0.515"
            ]
        },
        {
            "time": 5.8429999351501469,
            "data": [
                "prisoner,2.267,0.000,1.136,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.017,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.855,-0.056,0.514"
            ]
        },
        {
            "time": 5.85699987411499,
            "data": [
                "prisoner,2.276,0.000,1.142,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,1.002,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.856,-0.056,0.513"
            ]
        },
        {
            "time": 5.874000072479248,
            "data": [
                "prisoner,2.286,0.000,1.148,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.987,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.857,-0.056,0.512"
            ]
        },
        {
            "time": 5.892000198364258,
            "data": [
                "prisoner,2.298,0.000,1.154,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.971,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.857,-0.056,0.510"
            ]
        },
        {
            "time": 5.9029998779296879,
            "data": [
                "prisoner,2.311,0.000,1.162,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.955,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.858,-0.056,0.509"
            ]
        },
        {
            "time": 5.918000221252441,
            "data": [
                "prisoner,2.318,0.000,1.166,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.947,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.859,-0.056,0.508"
            ]
        },
        {
            "time": 5.934000015258789,
            "data": [
                "prisoner,2.329,0.000,1.172,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.936,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.859,-0.056,0.507"
            ]
        },
        {
            "time": 5.948999881744385,
            "data": [
                "prisoner,2.340,0.000,1.178,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.927,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.860,-0.056,0.506"
            ]
        },
        {
            "time": 5.965000152587891,
            "data": [
                "prisoner,2.350,0.000,1.184,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.919,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.861,-0.056,0.505"
            ]
        },
        {
            "time": 5.98199987411499,
            "data": [
                "prisoner,2.362,0.000,1.191,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.913,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.861,-0.057,0.504"
            ]
        },
        {
            "time": 5.994999885559082,
            "data": [
                "prisoner,2.373,0.000,1.198,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.910,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.862,-0.057,0.503"
            ]
        },
        {
            "time": 6.013000011444092,
            "data": [
                "prisoner,2.382,0.000,1.203,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.862,-0.057,0.502"
            ]
        },
        {
            "time": 6.021999835968018,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.0370001792907719,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.054999828338623,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.068999767303467,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.085999965667725,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.105000019073486,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.11899995803833,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.127999782562256,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.144000053405762,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.160999774932861,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.177000045776367,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.192999839782715,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.210999965667725,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.2210001945495609,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.236999988555908,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.252999782562256,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.267000198364258,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.284999847412109,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.297999858856201,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.313000202178955,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.328000068664551,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.341000080108643,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.357999801635742,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.374000072479248,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.388000011444092,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.4039998054504398,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.421999931335449,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.433000087738037,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.448999881744385,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.464000225067139,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.480000019073486,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.493000030517578,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        },
        {
            "time": 6.510000228881836,
            "data": [
                "prisoner,2.386,0.000,1.205,0.000,-0.500,0.000,-0.866",
                "citizenM,4.821,0.000,0.908,0.000,-1.000,0.000,0.000",
                "victimF,-0.484,0.018,-0.761,-0.569,0.413,0.399,0.589",
                "observationCamera,3.633,0.293,1.703,0.034,0.863,-0.057,0.501"
            ]
        }
    ]
};